import { Language } from './i18n';

export interface LocalizedFoodNameMap {
  [faName: string]: {
    en: string;
    sv: string;
    enQty?: string;
    svQty?: string;
  };
}

export const FOOD_TRANSLATIONS: LocalizedFoodNameMap = {
  // Fruits
  'سیب سرخ / زرد': { en: 'Red / Yellow Apple', sv: 'Rött / Gult äpple', enQty: '1 medium (150g)', svQty: '1 st medelstor (150 g)' },
  'موز رسیده‌': { en: 'Ripe Banana', sv: 'Mogen banan', enQty: '1 medium (120g)', svQty: '1 st medelstor (120 g)' },
  'پرتقال تامسون': { en: 'Orange', sv: 'Apelsin', enQty: '1 piece (180g)', svQty: '1 st (180 g)' },
  'نارنگی شیرین': { en: 'Mandarin / Clementine', sv: 'Mandarin / Klementin', enQty: '1 piece (90g)', svQty: '1 st (90 g)' },
  'خیار بوته‌ای': { en: 'Cucumber', sv: 'Gurka', enQty: '2 pieces (150g)', svQty: '2 st (150 g)' },
  'گوجه‌فرنگی تازه': { en: 'Fresh Tomato', sv: 'Färsk tomat', enQty: '1 piece (120g)', svQty: '1 st (120 g)' },
  'هندوانه شیرین': { en: 'Sweet Watermelon', sv: 'Söt vattenmelon', enQty: '1 slice (300g)', svQty: '1 skiva (300 g)' },
  'خربزه / طالبی / ملون': { en: 'Melon / Cantaloupe', sv: 'Melon / Cantaloupe', enQty: '1 slice (250g)', svQty: '1 skiva (250 g)' },
  'توت‌فرنگی تازه': { en: 'Fresh Strawberries', sv: 'Färska jordgubbar', enQty: '1 bowl (150g)', svQty: '1 skål (150 g)' },
  'انگور عسگری / یاقوتی': { en: 'Grapes', sv: 'Vindruvor', enQty: '1 cluster (150g)', svQty: '1 klase (150 g)' },
  'هلو / شلیل': { en: 'Peach / Nectarine', sv: 'Persika / Nektarin', enQty: '1 piece (130g)', svQty: '1 st (130 g)' },
  'زردآلو تازه': { en: 'Fresh Apricots', sv: 'Färska aprikoser', enQty: '3 pieces (100g)', svQty: '3 st (100 g)' },
  'گیلاس / آلبالو': { en: 'Cherries / Sour Cherries', sv: 'Körsbär / Moreller', enQty: '1 bowl (120g)', svQty: '1 skål (120 g)' },
  'انار ساوه': { en: 'Pomegranate', sv: 'Granatäpple', enQty: '1 piece (200g)', svQty: '1 st (200 g)' },
  'کیوی': { en: 'Kiwi', sv: 'Kiwi', enQty: '2 pieces (140g)', svQty: '2 st (140 g)' },
  'انجیر تازه': { en: 'Fresh Figs', sv: 'Färska fikon', enQty: '3 pieces (100g)', svQty: '3 st (100 g)' },
  'انجیر خشک': { en: 'Dried Figs', sv: 'Torkade fikon', enQty: '4 pieces (50g)', svQty: '4 st (50 g)' },
  'خرمالو شیرین': { en: 'Persimmon', sv: 'Kaki / Persimon', enQty: '1 piece (100g)', svQty: '1 st (100 g)' },
  'لیمو شیرین': { en: 'Sweet Lemon', sv: 'Sötcitron', enQty: '1 piece (150g)', svQty: '1 st (150 g)' },
  'خرما مضافتی / مدجول': { en: 'Dates (Mazafati / Medjool)', sv: 'Dadlar (Mazafati / Medjool)', enQty: '3 pieces (45g)', svQty: '3 st (45 g)' },
  'کشمش / مویز': { en: 'Raisins', sv: 'Russin', enQty: '1 handful (30g)', svQty: '1 näve (30 g)' },
  'برگه زردآلو / قیسی': { en: 'Dried Apricots', sv: 'Torkade aprikoser', enQty: '50g', svQty: '50 g' },
  'انبه استوایی': { en: 'Mango', sv: 'Mango', enQty: '1 piece (200g)', svQty: '1 st (200 g)' },
  'آناناس تازه': { en: 'Fresh Pineapple', sv: 'Färsk ananas', enQty: '2 slices (120g)', svQty: '2 skivor (120 g)' },
  'آووکادو': { en: 'Avocado', sv: 'Avokado', enQty: '1/2 piece (100g)', svQty: '1/2 st (100 g)' },
  'زیتون سبز / سیاه': { en: 'Green / Black Olives', sv: 'Gröna / Svarta oliver', enQty: '10 pieces (40g)', svQty: '10 st (40 g)' },

  // Persian Dishes & Seasonal Meals
  'خورشت قرمه‌سبزی با چلو': { en: 'Ghormeh Sabzi Herb Stew with Rice', sv: 'Ghormeh Sabzi med ris', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش قورمه سبزی (ترکیبات تلخ)': { en: 'Ghormeh Sabzi (Bitter Herb GLP-1 Stew)', sv: 'Ghormeh Sabzi (örtrik gryta)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش قورمه سبزی با لیمو': { en: 'Ghormeh Sabzi with Dried Lime & Rice', sv: 'Ghormeh Sabzi med torkad lime & ris', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورشت قیمه بادمجان با چلو': { en: 'Gheimeh Stew with Eggplant & Rice', sv: 'Gheimeh Bademjan med ris', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش قیمه (لپه/پروتئین)': { en: 'Gheimeh Split Pea & Lean Beef Stew', sv: 'Gheimeh (gul ärta & nötköttsgryta)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش قیمه زردچوبه‌ای': { en: 'Turmeric Gheimeh Stew with Rice', sv: 'Gurkmeja Gheimeh-gryta med ris', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورشت فسنجان مرغ با چلو': { en: 'Fesenjan Chicken Stew with Rice', sv: 'Fesenjan med kyckling & ris', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش فسنجان (گردو/چربی مفید)': { en: 'Walnut & Pomegranate Fesenjan Stew', sv: 'Fesenjan (valnötter & granatäpple)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش فسنجان مرغ ترش': { en: 'Sour Fesenjan with Chicken Breast', sv: 'Syrlig Fesenjan med kycklingfilé', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورشت کرفس با چلو': { en: 'Celery Stew with Rice', sv: 'Karafsh (sellerigryta) med ris', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش کرفس (فیبر/تلخ)': { en: 'High-Fiber Celery & Mint Stew', sv: 'Selleri- & myntagryta (Karafsh)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش کرفس با مرغ ترش': { en: 'Sour Celery Stew with Chicken', sv: 'Sellerigryta med kyckling & lime', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورشت بامیه با چلو': { en: 'Okra Stew with Rice', sv: 'Bamieh (okragryta) med ris', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش بامیه (فیبر فوق‌العاده)': { en: 'High-Fiber Okra & Garlic Stew', sv: 'Okragryta med vitlök & tomat (Bamieh)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش بامیه با سیر تازه': { en: 'Okra Stew with Fresh Garlic', sv: 'Okragryta med färsk vitlök', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش بادمجان (کبابی)': { en: 'Roasted Eggplant Stew (Low Oil)', sv: 'Ugnsrostad auberginegryta (låg olja)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش بادمجان تنوری': { en: 'Baked Eggplant Stew with Lean Beef', sv: 'Ugnsbakad auberginegryta med magert kött', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش آلو اسفناج (تلخ/فیبر)': { en: 'Spinach & Plum Stew (Aloo Esfenaj)', sv: 'Spenat- & plommongryta (Aloo Esfenaj)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش آلو اسفناج تازه': { en: 'Fresh Autumn Spinach & Plum Stew', sv: 'Färsk spenat- & plommongryta', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش به (دانش عمومی)': { en: 'Quince & Plum Stew (Khoresht Beh)', sv: 'Kvittengryta med plommon (Khoresht Beh)', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش به با گوشت لخم': { en: 'Quince Stew with Lean Beef & Rice', sv: 'Kvittengryta med magert nötkött', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش ریواس یا گوجه سبز': { en: 'Rhubarb / Green Plum Sour Stew', sv: 'Rabarber- / Grön plommongryta', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش گوجه سبز با مرغ': { en: 'Sour Green Plum Stew with Chicken', sv: 'Grön plommongryta med kyckling', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش کدو و آلوبخارا': { en: 'Zucchini & Bukhara Plum Stew', sv: 'Zucchinigryta med Bukhara-plommon', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش کدو سبز و آلوبخارا': { en: 'Zucchini & Plum Stew with Rice', sv: 'Zucchinigryta med ris & plommon', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش لپه با مرغ': { en: 'Yellow Split Pea Stew with Chicken', sv: 'Gula ärtor-gryta med kyckling', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'خورش لپه و سینه مرغ': { en: 'Split Pea Stew with Chicken Breast', sv: 'Gula ärtor-gryta med kycklingbröst', enQty: '1 plate (400g)', svQty: '1 portion (400 g)' },
  'چلو کباب کوبیده (۲ سیخ)': { en: 'Kebab Koobideh (2 skewers) with Rice', sv: 'Kebab Koobideh (2 spett) med ris', enQty: '1 portion (450g)', svQty: '1 portion (450 g)' },
  'چلو کباب کوبیده (سره)': { en: 'Lean Beef Koobideh Kebab with Rice', sv: 'Mager Kebab Koobideh med ris', enQty: '1 portion (450g)', svQty: '1 portion (450 g)' },
  'چلو کباب کوبیده زعفرانی': { en: 'Saffron Koobideh Kebab with Steamed Rice', sv: 'Saffrans-Koobideh kebab med ris', enQty: '1 portion (450g)', svQty: '1 portion (450 g)' },
  'جوجه کباب زعفرانی با برنج': { en: 'Saffron Chicken Kebab with Rice', sv: 'Saffranskyckling (Joojeh) med ris', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'جوجه کباب با شاهی': { en: 'Saffron Chicken Kebab with Watercress', sv: 'Grillad kycklingkebab med krasse & ris', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'جوجه کباب با شاهی و لیمو': { en: 'Chicken Kebab with Watercress & Lemon', sv: 'Kycklingkebab med krasse & citron', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'جوجه کباب لاری (ماست)': { en: 'Lari Yogurt-Marinated Chicken Kebab', sv: 'Lari-marinerad kycklingkebab med yoghurt', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'جوجه کباب لاری با لیمو': { en: 'Lari Chicken Kebab with Lemon & Rice', sv: 'Lari kycklingkebab med citron & ris', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'کباب برگ گوسفندی': { en: 'Lamb Fillet Kebab (Barg)', sv: 'Kebab Barg (lammfilé)', enQty: '1 skewer (200g)', svQty: '1 spett (200 g)' },
  'کباب تابه ای با روغن زیتون': { en: 'Pan Kebab with Extra Virgin Olive Oil', sv: 'Persisk pannbiff (Kabab Tabei) med olivolja', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کباب تابه ای بوقلمون با زیتون': { en: 'Turkey Pan Kebab with Olive Oil', sv: 'Kalkonpannbiff med olivolja & ris', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کباب تابه ای بوقلمون': { en: 'Lean Turkey Pan Kebab with Grilled Tomato', sv: 'Kalkon-pannbiff med grillad tomat', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کباب تابه ای بوقلمون زردچوبه‌ای': { en: 'Turmeric Spiced Turkey Pan Kebab', sv: 'Gurkmejakryddad kalkonpannbiff', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کباب حسینی (پروتئین)': { en: 'Hosseini Skewered Beef & Bell Peppers', sv: 'Hosseini spettbiff med paprika & tomat', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کباب حسینی راسته گوساله': { en: 'Sirloin Beef Hosseini Skewered Kebab', sv: 'Oxfilé Hosseini grillspett med ris', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کباب چنجه (راسته گوساله)': { en: 'Chenjeh Sirloin Steak Kebab with Rice', sv: 'Chenjeh biffkebab med ris & sumak', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کباب چنجه راسته گوساله': { en: 'Chenjeh Beef Steak with Saffron Rice', sv: 'Chenjeh biff med saffransris', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'چلو ماهیچه گوسفندی': { en: 'Lamb Shank with Rice', sv: 'Lammstek (Mahicheh) med ris', enQty: '1 portion (450g)', svQty: '1 portion (450 g)' },
  'زرشک پلو با مرغ': { en: 'Barberry Rice with Chicken', sv: 'Zereshk Polo (barberry-ris) med kyckling', enQty: '1 portion (450g)', svQty: '1 portion (450 g)' },
  'باقالی پلو با ماهیچه': { en: 'Dill & Fava Bean Rice with Lamb Shank', sv: 'Baghali Polo med lammstek', enQty: '1 portion (500g)', svQty: '1 portion (500 g)' },
  'باقالی پلو با مرغ (فیبر بالا)': { en: 'Fava Bean & Dill Rice with Chicken Breast', sv: 'Baghali Polo med kyckling (högfiber)', enQty: '1 portion (450g)', svQty: '1 portion (450 g)' },
  'باقالی پلو با گوشت لخم': { en: 'Fava Bean Rice with Lean Beef', sv: 'Baghali Polo med magert kött', enQty: '1 portion (450g)', svQty: '1 portion (450 g)' },
  'ته چین مرغ زعفرانی': { en: 'Crispy Saffron Rice Cake with Chicken (Tahchin)', sv: 'Tahchin (saffransriskaka) med kyckling', enQty: '1 slice (300g)', svQty: '1 bit (300 g)' },
  'ته چین مرغ (پروتئین لبنی)': { en: 'Tahchin Saffron Rice with Greek Yogurt & Chicken', sv: 'Tahchin med grekisk yoghurt & kyckling', enQty: '1 slice (300g)', svQty: '1 bit (300 g)' },
  'ته چین مرغ با ماست یونانی': { en: 'High-Protein Greek Yogurt Tahchin', sv: 'Proteinrik Tahchin med grekisk yoghurt', enQty: '1 slice (300g)', svQty: '1 bit (300 g)' },
  'لوبیا پلو با گوشت تکه‌ای': { en: 'Green Bean Rice with Beef (Lubia Polo)', sv: 'Lubia Polo (gröna bönor & ris) med kött', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'لوبیا پلو (کم روغن)': { en: 'Green Bean Rice with Lean Beef (Low Oil)', sv: 'Lubia Polo (gröna bönor & ris, låg olja)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'عدس پلو با کشمش و خرما': { en: 'Lentil Rice with Raisins & Dates', sv: 'Adas Polo (linsris) med russin & dadlar', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'عدس پلو با گوشت چرخ‌کرده': { en: 'High-Fiber Lentil Rice with Lean Minced Beef', sv: 'Adas Polo (linsris med köttfärs & kanel)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'عدس پلو با کشمش و گوشت': { en: 'Lentil Rice with Lean Beef & Raisins', sv: 'Adas Polo med magert kött & russin', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'ماش پلو (فیبر بالا)': { en: 'Mung Bean Rice with Dill & Lean Beef', sv: 'Mash Polo (mungbönor & dillris med kött)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'ماش پلو با شوید': { en: 'Mung Bean & Dill Rice with Beef', sv: 'Mungbönsris med dill & magert kött', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'هویج پلو با مرغ (فیبر)': { en: 'Carrot Rice with Saffron Chicken & Almonds', sv: 'Havij Polo (morotsris med kyckling & mandel)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'هویج پلو با خلال بادام': { en: 'Carrot Rice with Chicken & Slivered Almonds', sv: 'Morotsris med kycklingfilé & mandelspån', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'استانبولی پلو با گوجه و گوشت': { en: 'Tomato Rice with Minced Beef (Eslamboli)', sv: 'Eslamboli Polo (tomatris med köttfärs)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'استانبولی با لوبیا سبز': { en: 'Tomato & Green Bean Rice with Chicken', sv: 'Eslamboli med gröna bönor & kyckling', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'استانبولی پلو با فیله مرغ': { en: 'Tomato Rice with Chicken Fillet', sv: 'Eslamboli tomatris med kycklingfilé', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کلم پلو شیرازی': { en: 'Shirazi Cabbage Rice with Meatballs', sv: 'Kalam Polo Shirazi (kålris med köttbullar)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کلم پلو شیرازی (کلم/فیبر)': { en: 'High-Fiber Shirazi Cabbage Rice with Herbs', sv: 'Kalam Polo Shirazi (kålris med dragon & köttbullar)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کلم پلو شیرازی با ترخون': { en: 'Shirazi Cabbage Rice with Tarragon & Meatballs', sv: 'Kalam Polo Shirazi med dragon & köttbullar', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'آلبالو پلو با مرغ': { en: 'Sour Cherry Rice with Chicken', sv: 'Albaloo Polo (körsbärsris) med kyckling', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کته با ماست یونانی و گردو': { en: 'Steamed Rice with Greek Yogurt, Walnuts & Mint', sv: 'Ris med grekisk yoghurt, valnötter & mynta', enQty: '1 plate (350g)', svQty: '1 tallrik (350 g)' },
  'آبگوشت / دیزی سنتی': { en: 'Traditional Lamb Dizi Stew', sv: 'Abgoosht / Dizi (traditionell lammgryta)', enQty: '1 bowl (400g)', svQty: '1 skål (400 g)' },
  'آبگوشت (دیزی کم‌چرب)': { en: 'Low-Fat Lamb & Chickpea Dizi Stew', sv: 'Mager Dizi-lammgryta med kikärtor & bönor', enQty: '1 bowl (400g)', svQty: '1 skål (400 g)' },
  'آبگوشت دیزی با سبزی خوردن': { en: 'Traditional Dizi Stew with Fresh Herbs', sv: 'Dizi lammgryta med färska örter & sangak', enQty: '1 bowl (400g)', svQty: '1 skål (400 g)' },
  'کشک بادمجان سنتی': { en: 'Eggplant Dip with Whey (Kashk-e Bademjan)', sv: 'Kashk-e Bademjan (aubergineröra)', enQty: '1 plate (250g)', svQty: '1 tallrik (250 g)' },
  'میرزا قاسمی رشتی': { en: 'Smoked Eggplant with Garlic & Egg (Mirza Ghasemi)', sv: 'Mirza Ghasemi (rökt aubergineröra)', enQty: '1 plate (250g)', svQty: '1 tallrik (250 g)' },
  'کوکو سبزی خانگی': { en: 'Persian Herb Frittata (Kuku Sabzi)', sv: 'Kuku Sabzi (persisk örtomelett)', enQty: '3 pieces (150g)', svQty: '3 bitar (150 g)' },
  'کوکو سبزی (گردو و زرشک)': { en: 'Herb Frittata with Walnuts & Barberries', sv: 'Örtomelett (Kuku Sabzi) med valnötter & berberis', enQty: '3 pieces (150g)', svQty: '3 bitar (150 g)' },
  'کوکو سبزی پخته در فر': { en: 'Oven-Baked Herb Frittata with Sangak Bread', sv: 'Ugnsbakad Kuku Sabzi med sangak-bröd', enQty: '3 pieces (150g)', svQty: '3 bitar (150 g)' },
  'کوکو سیب‌زمینی': { en: 'Potato Patties (Kuku Sibzamini)', sv: 'Kuku Sibzamini (potatisbiffar)', enQty: '2 pieces (160g)', svQty: '2 st (160 g)' },
  'کتلت گوشت خانگی': { en: 'Persian Meat & Potato Cutlets (Kotlet)', sv: 'Kotlet (persiska köttbiffar)', enQty: '3 pieces (180g)', svQty: '3 st (180 g)' },
  'کتلت فرپز (کم چرب)': { en: 'Oven-Baked Low-Fat Beef Cutlets', sv: 'Ugnsbakade magra köttbiffar (Kotlet)', enQty: '3 pieces (180g)', svQty: '3 st (180 g)' },
  'کتلت کم‌چرب تنوری': { en: 'Baked Cutlets with Fresh Sangak Bread', sv: 'Ugnsbakade kotletter med sangakbröd', enQty: '3 pieces (180g)', svQty: '3 st (180 g)' },
  'شامی پوک (لپه/پروتئین)': { en: 'Persian Split Pea & Beef Shami Patties', sv: 'Shami Pook (biffar på gula ärtor & nötkött)', enQty: '3 pieces (180g)', svQty: '3 st (180 g)' },
  'شامی پوک لپه‌دار': { en: 'Crispy Split Pea Shami with Fresh Herbs', sv: 'Shami Pook med färska örter & tomat', enQty: '3 pieces (180g)', svQty: '3 st (180 g)' },
  'دلمه برگ مو / فلفل': { en: 'Stuffed Grape Leaves / Peppers (Dolma)', sv: 'Dolma (fyllda vinblad / paprika)', enQty: '4 pieces (250g)', svQty: '4 st (250 g)' },
  'دلمه برگ مو (حبوبات/فیبر)': { en: 'Stuffed Grape Leaves with Split Peas & Herbs', sv: 'Fyllda vinblad (Dolma) med baljväxter & örter', enQty: '5-6 pieces (250g)', svQty: '5-6 st (250 g)' },
  'دلمه برگ مو ویژه بهار': { en: 'Spring Fresh Herb & Lean Beef Dolma', sv: 'Vår-Dolma med färska vinblad & örter', enQty: '6 pieces (250g)', svQty: '6 st (250 g)' },
  'کوفته تبریزی': { en: 'Tabrizi Giant Meatball', sv: 'Kofteh Tabrizi (fylld jätteköttbulle)', enQty: '1 large piece (300g)', svQty: '1 st stor (300 g)' },
  'کوفته تبریزی (گردو/لپه)': { en: 'Tabrizi Giant Meatball with Walnuts & Prunes', sv: 'Kofteh Tabrizi med valnötter & plommon', enQty: '1 large piece (300g)', svQty: '1 st stor (300 g)' },
  'کوفته تبریزی گردودار': { en: 'Tabrizi Meatball with Walnut Core', sv: 'Kofteh Tabrizi fylld med valnötter', enQty: '1 large piece (300g)', svQty: '1 st stor (300 g)' },
  'مرغ ترش (سبزیجات محلی)': { en: 'Gilani Sour Chicken with Walnuts & Herbs', sv: 'Morgh Torsh (nordpersisk kyckling med örter & valnötter)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'مرغ ترش گیلانی': { en: 'Sour Herb Chicken with Pomegranate Molasses', sv: 'Morgh Torsh med granatäppelsirap & valnötter', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'مرغ شکمپر با گردو': { en: 'Stuffed Roast Chicken with Walnuts & Pomegranate', sv: 'Ugnsstekt kyckling fylld med valnötter & berberis', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'مرغ شکم‌پر پاییزی': { en: 'Autumn Stuffed Chicken with Walnuts', sv: 'Höstkyckling fylld med valnötter', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'استیک مرغ با کلم بروکلی': { en: 'Grilled Chicken Steak with Steamed Broccoli', sv: 'Grillad kycklingfilé med ångkokt broccoli', enQty: '1 portion (300g)', svQty: '1 portion (300 g)' },
  'استیک مرغ و بروکلی گریل': { en: 'Chicken Breast Steak with Olive Oil & Broccoli', sv: 'Kycklingbröst med olivolja & grillad broccoli', enQty: '1 portion (300g)', svQty: '1 portion (300 g)' },
  'خوراک مرغ و سبزیجات': { en: 'Steamed Chicken with Garden Vegetables & Barley Bread', sv: 'Kycklinggryta med grönsaker & kornbröd', enQty: '1 portion (300g)', svQty: '1 portion (300 g)' },
  'خوراک مرغ و قارچ و کدو': { en: 'Chicken, Mushroom & Zucchini Skillet', sv: 'Kyckling, champinjoner & zucchini med kornbröd', enQty: '1 portion (300g)', svQty: '1 portion (300 g)' },
  'خوراک زبان یا گوشت لخم': { en: 'Lean Beef / Tongue with Mushroom Sauce', sv: 'Magert nötkött med champinjonsås & sangak', enQty: '1 portion (300g)', svQty: '1 portion (300 g)' },
  'خوراک گوشت لخم با سس قارچ': { en: 'Lean Beef Tenderloin in Mushroom Sauce', sv: 'Oxfilé / Magert kött i champinjonsås', enQty: '1 portion (300g)', svQty: '1 portion (300 g)' },
  'تاس کباب (گوشت و به)': { en: 'Tas Kebab (Beef, Quince, Carrots & Sangak Bread)', sv: 'Tas Kebab (nötkött, kvitten, morötter & sangak)', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'تاس کباب گوشت و به زمستانی': { en: 'Winter Tas Kebab Stew with Root Veggies', sv: 'Vinter Tas Kebab med rotfrukter & sangak', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'آبدوغ خیار (گردو/نعنا/پروتئین)': { en: 'Chilled Yogurt Cucumber Soup with Walnuts & Sangak', sv: 'Abdoogh Khiar (kall yoghurtröra med valnötter & mynta)', enQty: '1 bowl (400g)', svQty: '1 skål (400 g)' },
  'آبدوغ خیار سنتی با گردو': { en: 'Traditional Cold Yogurt Soup with Walnuts & Herbs', sv: 'Traditionell kall yoghurtröra med valnötter', enQty: '1 bowl (400g)', svQty: '1 skål (400 g)' },
  'کدو سبز سوخاری در فر': { en: 'Crispy Baked Zucchini with Grilled Chicken Fillet', sv: 'Ugnsbakad krispig zucchini med grillad kycklingfilé', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کدو سبز تنوری با فیله مرغ': { en: 'Roasted Zucchini with Chicken Breast & Garlic Dip', sv: 'Ugnsrostad zucchini med kycklingbröst & vitlöksdipp', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'کدو حلوایی و تکه‌های گوشت': { en: 'Roasted Butternut Squash with Lean Beef & Cinnamon', sv: 'Ugnsbakad pumpa med magert nötkött & kanel', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'خوراک کدو حلوایی و دارچین': { en: 'Cinnamon Spiced Pumpkin & Beef with Barley Bread', sv: 'Kanelkryddad pumpagryta med nötkött & kornbröd', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'ماهی با سبزی پلو': { en: 'Grilled Trout/Salmon with Fresh Herb Rice', sv: 'Grillad lax/forell med ört- & dillris', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'ماهی قزل‌آلا تنوری با سبزی پلو': { en: 'Baked Trout with Saffron Herb Rice', sv: 'Ugnsbakad forell med saffransört-ris', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'ماهی کبابی با لیمو': { en: 'Grilled Salmon with Turmeric, Black Pepper & Veggies', sv: 'Grillad lax med gurkmeja, svartpeppar & grönsaker', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'ماهی کباب شده با زردچوبه': { en: 'Turmeric Grilled Fish Fillet with Roasted Greens', sv: 'Gurkmejagrillad fiskfilé med rostade grönsaker', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'ماهی سالمون در فر': { en: 'Oven-Baked Salmon Fillet with Autumn Veggies', sv: 'Ugnsbakad laxfilé med höstgrönsaker & vitlök', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'ماهی سالمون با لیمو و سیر': { en: 'Garlic Lemon Baked Salmon with Fresh Olives', sv: 'Vitlöks- & citronbakad lax med färska oliver', enQty: '1 portion (350g)', svQty: '1 portion (350 g)' },
  'سبزی پلو با ماهی آزاد': { en: 'Fresh Herb Rice with Wild Salmon & Garlic Pickles', sv: 'Örtris (Sabzi Polo) med lax & vitlök', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'سبزی پلو با ماهی سالمون': { en: 'Saffron Herb Rice with Grilled Salmon Fillet', sv: 'Saffransört-ris med grillad laxfilé', enQty: '1 portion (400g)', svQty: '1 portion (400 g)' },
  'سالاد پروتئین با کینوا': { en: 'Quinoa & Grilled Chicken Protein Salad with Olives', sv: 'Proteinsallad med quinoa, grillad kyckling & oliver', enQty: '1 large bowl (350g)', svQty: '1 stor skål (350 g)' },
  'سالاد کینوا و فیله مرغ': { en: 'Mediterranean Quinoa Salad with Chicken & Walnuts', sv: 'Medelhavssallad med quinoa, kyckling & valnötter', enQty: '1 large bowl (350g)', svQty: '1 stor skål (350 g)' },
  'آش رشته با کشک': { en: 'Persian Noodle & Legume Soup (Ash Reshteh)', sv: 'Ash Reshteh (nudel- & örtsoppa)', enQty: '1 bowl (350g)', svQty: '1 skål (350 g)' },
  'آش رشته (حبوبات کامل)': { en: 'Whole Legume Ash Reshteh with Low-Fat Whey', sv: 'Ash Reshteh med baljväxter, örter & kashk', enQty: '1 bowl (350g)', svQty: '1 skål (350 g)' },
  'آش رشته پرسبزی و کشک': { en: 'Herb-Rich Ash Reshteh with Sautéed Garlic', sv: 'Örtrik Ash Reshteh med stekt vitlök & kashk', enQty: '1 bowl (350g)', svQty: '1 skål (350 g)' },
  'آش جو (فیبر فراوان)': { en: 'High-Fiber Pearl Barley & Legume Herb Soup', sv: 'Kornsoppa med baljväxter & örter (Ash-e Joe)', enQty: '1 bowl (350g)', svQty: '1 skål (350 g)' },
  'آش جو با کشک و نعنا': { en: 'Barley Herb Soup with Mint & Whey', sv: 'Kornsoppa med mynta & kashk', enQty: '1 bowl (350g)', svQty: '1 skål (350 g)' },
  'عدسی خانگی': { en: 'Lentil Soup (Adasi)', sv: 'Adasi (linsgryta)', enQty: '1 bowl (250g)', svQty: '1 skål (250 g)' },
  'عدسی با پیاز داغ زردچوبه': { en: 'Thick Green Lentil Soup with Turmeric & Olive Oil', sv: 'Fyllig linssoppa med gurkmeja & olivolja', enQty: '1 bowl (300g)', svQty: '1 skål (300 g)' },
  'عدسی غلیظ با لیموترش': { en: 'Hearty Lentil Soup with Fresh Lemon & Sangak', sv: 'Fyllig linsgryta med citron & sangakbröd', enQty: '1 bowl (300g)', svQty: '1 skål (300 g)' },
  'خوراک لوبیا چیتی با قارچ': { en: 'Pinto Bean Stew with Mushrooms', sv: 'Böngryta med champinjoner', enQty: '1 bowl (250g)', svQty: '1 skål (250 g)' },
  'خوراک دال عدس': { en: 'Spicy Red Lentil Stew with Garlic & Tamarind', sv: 'Kryddig röd linsgryta med vitlök & tamarind', enQty: '1 bowl (300g)', svQty: '1 skål (300 g)' },
  'خوراک دال عدس با سیر': { en: 'Red Lentil Stew with Sautéed Garlic & Rice', sv: 'Röd linsgryta med vitlök & basmatiris', enQty: '1 bowl (300g)', svQty: '1 skål (300 g)' },
  'نرگسی اسفناج (تلخ/تخم‌مرغ)': { en: 'Nargesi (Fresh Sautéed Spinach with Eggs & Garlic)', sv: 'Nargesi (stekt spenat med ägg & vitlök)', enQty: '1 plate (250g)', svQty: '1 tallrik (250 g)' },
  'نرگسی اسفناج و سیر تازه': { en: 'Spinach & Egg Frittata with Fresh Garlic & Olives', sv: 'Spenat- & äggrätt med färsk vitlök & oliver', enQty: '1 plate (250g)', svQty: '1 tallrik (250 g)' },
  'حلیم بادمجان (عدس/گوشت)': { en: 'Haleem Bademjan (Eggplant, Lentil & Shredded Beef)', sv: 'Haleem Bademjan (aubergine, linser & nötkött)', enQty: '1 plate (300g)', svQty: '1 tallrik (300 g)' },
  'حلیم بادمجان کشک‌دار': { en: 'Eggplant & Beef Dip with Sautéed Mint & Walnuts', sv: 'Aubergineröra med kött, mynta & valnötter', enQty: '1 plate (300g)', svQty: '1 tallrik (300 g)' },
  'سوپ مرغ و سبزیجات (داغ)': { en: 'Hot Chicken & Vegetable Barley Soup', sv: 'Varm kyckling- & grönsakssoppa med korn', enQty: '1 bowl (400g)', svQty: '1 skål (400 g)' },
  'سوپ مرغ و جو پوست‌کنده': { en: 'Shredded Chicken & Pearl Barley Soup with Lemon', sv: 'Kyckling- & kornsoppa med färsk citron', enQty: '1 bowl (400g)', svQty: '1 skål (400 g)' },
  'سوپ جو با شیر و قارچ': { en: 'Creamy Barley & Mushroom Soup with Chicken', sv: 'Kornsoppa med champinjoner & kyckling', enQty: '1 bowl (350g)', svQty: '1 skål (350 g)' },
  'سوپ جو پرک با مرغ': { en: 'Barley Soup with Chicken', sv: 'Kornsoppa med kyckling & morötter', enQty: '1 bowl (250g)', svQty: '1 skål (250 g)' },

  // Snacks & Drinks
  'قهوه سلامتی (کولد برو) + ماست یونانی و دانه چیا': { en: 'GLP-1 Health Coffee (Cold Brew) + Greek Yogurt & Chia Seeds', sv: 'GLP-1 Hälsokaffe (Cold Brew) + Grekisk yoghurt & Chiafrön', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'قهوه سلامتی (کولد برو) + ماست یونانی و چیا': { en: 'GLP-1 Health Coffee (Cold Brew) + Greek Yogurt & Chia', sv: 'GLP-1 Hälsokaffe (Cold Brew) + Grekisk yoghurt & Chia', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'قهوه سلامتی GLP-1 (کولد برو / اسپرسو + گردو و چیا)': { en: 'GLP-1 Health Coffee (Cold Brew / Espresso + Walnuts & Chia)', sv: 'GLP-1 Hälsokaffe (Cold Brew / Espresso + Valnötter & Chia)', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'قهوه سلامتی + ماست یونانی و گردو': { en: 'Health Coffee + Greek Yogurt & Walnuts', sv: 'Hälsokaffe + Grekisk yoghurt & Valnötter', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'قهوه سلامتی (کولد برو) + ماست یونانی': { en: 'Health Coffee (Cold Brew) + Greek Yogurt', sv: 'Hälsokaffe (Cold Brew) + Grekisk yoghurt', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'قهوه سلامتی + ماست یونانی و دانه چیا': { en: 'Health Coffee + Greek Yogurt & Chia Seeds', sv: 'Hälsokaffe + Grekisk yoghurt & Chiafrön', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'قهوه سلامتی (اسپرسو) + ماست یونانی و چیا': { en: 'Health Coffee (Espresso) + Greek Yogurt & Chia', sv: 'Hälsokaffe (Espresso) + Grekisk yoghurt & Chiafrön', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'ماست یونانی با گردو و دارچین': { en: 'Greek Yogurt with Walnuts & Cinnamon', sv: 'Grekisk yoghurt med valnötter & kanel', enQty: '1 bowl (200g)', svQty: '1 skål (200 g)' },
  'سیب و کره بادام‌زمینی': { en: 'Apple Slices with Peanut Butter', sv: 'Äppelskivor med jordnötssmör', enQty: '1 apple + 1 tbsp butter', svQty: '1 äpple + 1 msk smör' },

  // Breakfast Items
  'املت گوجه‌فرنگی': { en: 'Tomato Omelet', sv: 'Tomatomelett', enQty: '1 plate (200g)', svQty: '1 tallrik (200 g)' },
  'املت قارچ و اسفناج': { en: 'Mushroom & Spinach Omelet', sv: 'Svamp- & spenatomelett', enQty: '1 plate (200g)', svQty: '1 tallrik (200 g)' },
  'تخم‌مرغ آب‌پز': { en: 'Boiled Eggs', sv: 'Kokt ägg', enQty: '2 large (110g)', svQty: '2 st stora (110 g)' },
  'تخم‌مرغ نیمرو با کره': { en: 'Fried Eggs with Butter', sv: 'Stekt ägg med smör', enQty: '2 pieces (120g)', svQty: '2 st (120 g)' },
  'نان و پنیر سفید و گردو': { en: 'Bread with Feta Cheese & Walnuts', sv: 'Bröd med fetaost & valnötter', enQty: '1 portion (120g)', svQty: '1 portion (120 g)' },
  'خامه و عسل': { en: 'Clotted Cream & Honey', sv: 'Grädde & honung', enQty: '70g', svQty: '70 g' },
  'کره و مربای خانگی': { en: 'Butter & Jam', sv: 'Smör & hemlagad sylt', enQty: '60g', svQty: '60 g' },
  'پنیر تبریزی / لیقوان': { en: 'Lighvan / Tabrizi Sheep Cheese', sv: 'Lighvan / Tabrizi fårost', enQty: '50g', svQty: '50 g' },
  'اوتمیل موز و کره بادام‌زمینی': { en: 'Oatmeal with Banana & Peanut Butter', sv: 'Havregrynsgröt med banan & jordnötssmör', enQty: '1 bowl (250g)', svQty: '1 skål (250 g)' },
  'نان سنگک تازه': { en: 'Fresh Sangak Bread', sv: 'Färskt Sangak-bröd', enQty: '1 large piece (100g)', svQty: '1 stor bit (100 g)' },
  'نان بربری': { en: 'Fresh Barbari Bread', sv: 'Färskt Barbari-bröd', enQty: '1 large piece (100g)', svQty: '1 stor bit (100 g)' },
  'نان تست سبوس‌دار جو': { en: 'Whole Grain Oat Toast', sv: 'Fullkornsrostbröd (havre)', enQty: '2 slices (60g)', svQty: '2 skivor (60 g)' },
  'نان لواش': { en: 'Lavash Flatbread', sv: 'Lavash-tunnbröd', enQty: '1 piece (60g)', svQty: '1 st (60 g)' },

  // Proteins
  'سینه مرغ گریل‌شده': { en: 'Grilled Chicken Breast', sv: 'Grillad kycklingfilé', enQty: '150g', svQty: '150 g' },
  'ران مرغ پخته بدون پوست': { en: 'Cooked Skinless Chicken Thigh', sv: 'Kokt kycklinglår utan skinn', enQty: '150g', svQty: '150 g' },
  'فیله ماهی سالمون گریل': { en: 'Grilled Salmon Fillet', sv: 'Grillad laxfilé', enQty: '150g', svQty: '150 g' },
  'ماهی قزل‌آلا کباب‌شده': { en: 'Grilled Trout', sv: 'Grillad regnbågsforell', enQty: '200g', svQty: '200 g' },
  'تن ماهی در روغن': { en: 'Canned Tuna in Oil', sv: 'Tonfisk i olja', enQty: '1 can (180g)', svQty: '1 burk (180 g)' },
  'تن ماهی در آب‌نمک': { en: 'Canned Tuna in Water', sv: 'Tonfisk i vatten', enQty: '1 can (180g)', svQty: '1 burk (180 g)' },
  'میگو گریل‌شده / پخته': { en: 'Grilled / Boiled Shrimp', sv: 'Grillade / Kokta räkor', enQty: '150g', svQty: '150 g' },
  'فیله گوساله کبابی': { en: 'Grilled Beef Tenderloin', sv: 'Grillad oxfilé / biff', enQty: '150g', svQty: '150 g' },
  'گوشت گوسفندی پخته': { en: 'Cooked Lamb Meat', sv: 'Kokt lammkött', enQty: '150g', svQty: '150 g' },
  'گوشت چرخ‌کرده سرخ‌شده': { en: 'Cooked Ground Beef', sv: 'Stekt nötfärs', enQty: '150g', svQty: '150 g' },
  'بوقلمون کباب‌شده': { en: 'Grilled Turkey Breast', sv: 'Grillat kalkonbröst', enQty: '150g', svQty: '150 g' },
  'سفیده تخم‌مرغ پخته': { en: 'Boiled Egg Whites', sv: 'Kokt äggvita', enQty: '4 pieces (130g)', svQty: '4 st (130 g)' },
  'پروتئین وی (Protein Whey)': { en: 'Whey Protein Powder', sv: 'Vassleprotein (Whey)', enQty: '1 scoop (30g)', svQty: '1 skopa (30 g)' },

  // Grains
  'برنج سفید کته زعفرانی': { en: 'Saffron Steamed Rice (Kateh)', sv: 'Saffransris (Kateh)', enQty: '1 portion (150g)', svQty: '1 portion (150 g)' },
  'برنج سفید آبکش': { en: 'Cooked Basmati Rice', sv: 'Vitt basmatiris', enQty: '1 portion (150g)', svQty: '1 portion (150 g)' },
  'برنج قهوه‌ای پخته': { en: 'Cooked Brown Rice', sv: 'Kokt råris / brunt ris', enQty: '1 portion (150g)', svQty: '1 portion (150 g)' },
  'کینوا پخته‌شده': { en: 'Cooked Quinoa', sv: 'Kokt quinoa', enQty: '1 portion (150g)', svQty: '1 portion (150 g)' },
  'جو دوسر / اوتمیل پخته': { en: 'Cooked Oatmeal / Porridge', sv: 'Havregrynsgröt / Kokt havre', enQty: '1 bowl (200g)', svQty: '1 skål (200 g)' },
  'نخود پخته': { en: 'Cooked Chickpeas', sv: 'Kokta kikärtor', enQty: '1 portion (150g)', svQty: '1 portion (150 g)' },
  'عدس پخته': { en: 'Cooked Lentils', sv: 'Kokta linser', enQty: '1 portion (150g)', svQty: '1 portion (150 g)' },

  // Vegetables
  'سالاد شیرازی با آبغوره': { en: 'Shirazi Salad with Verjuice & Olive Oil', sv: 'Shirazi-sallad med verjuice & olivolja', enQty: '1 bowl (200g)', svQty: '1 skål (200 g)' },
  'سبزی خوردن تازه': { en: 'Fresh Persian Herbs (Sabzi Khordan)', sv: 'Sabzi Khordan (färsk örtblandning)', enQty: '1 plate (100g)', svQty: '1 tallrik (100 g)' },
  'کلم بروکلی بخارپز': { en: 'Steamed Broccoli', sv: 'Ångkokt broccoli', enQty: '150g', svQty: '150 g' },
  'قارچ کبابی / بخارپز': { en: 'Grilled / Steamed Mushrooms', sv: 'Grillade / Ångkokta champinjoner', enQty: '150g', svQty: '150 g' },
  'اسفناج پخته / نرگسی': { en: 'Cooked Spinach / Nargesi', sv: 'Spenat (Nargesi)', enQty: '150g', svQty: '150 g' },

  // Dairy & Nuts
  'ماست یونانی پرپروتئین': { en: 'Greek High-Protein Yogurt', sv: 'Grekisk proteinrik yoghurt', enQty: '200g', svQty: '200 g' },
  'ماست کم‌چرب': { en: 'Low-Fat Yogurt', sv: 'Lätt yoghurt', enQty: '1 cup (240g)', svQty: '1 glas (240 g)' },
  'ماست پرچرب / چکیده': { en: 'Strained / Full-Fat Yogurt', sv: 'Silad / Fyllig fet yoghurt', enQty: '150g', svQty: '150 g' },
  'ماست و خیار خانگی': { en: 'Yogurt with Cucumber & Mint (Mast-o-Khiar)', sv: 'Mast-o-Khiar (yoghurtröra med gurka)', enQty: '1 bowl (200g)', svQty: '1 skål (200 g)' },
  'ماست و موسیر': { en: 'Shallot Yogurt Dip (Mast-o-Musir)', sv: 'Mast-o-Musir (persisk schalottenlöksyoghurt)', enQty: '1 bowl (150g)', svQty: '1 skål (150 g)' },
  'دوغ نعنایی کم‌چرب': { en: 'Low-Fat Mint Doogh (Yogurt Drink)', sv: 'Doogh med mynta (låg fetthalt)', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'شیر کم‌چرب': { en: 'Low-Fat Milk', sv: 'Lättmjölk', enQty: '1 glass (240ml)', svQty: '1 glas (240 ml)' },
  'شیر پرچرب / کامل': { en: 'Whole Milk', sv: 'Standardmjölk', enQty: '1 glass (240ml)', svQty: '1 glas (240 ml)' },
  'کشک پاستوریزه': { en: 'Pasteurized Kashk (Whey)', sv: 'Pastöriserad Kashk (vassle)', enQty: '2 tbsp (50g)', svQty: '2 msk (50 g)' },
  'پنیر سفید فتا': { en: 'White Feta Cheese', sv: 'Vit fetaost', enQty: '50g', svQty: '50 g' },
  'سرشیر سنتی': { en: 'Traditional Clotted Cream (Sarshir)', sv: 'Sarshir (persisk frukostgrädde)', enQty: '50g', svQty: '50 g' },
  'گردو تازه / خشک': { en: 'Walnuts', sv: 'Valnötter', enQty: '5 pieces (30g)', svQty: '5 st (30 g)' },
  'بادام درختی خام': { en: 'Raw Almonds', sv: 'Rå sötmandel', enQty: '1 handful (30g)', svQty: '1 näve (30 g)' },
  'پسته رفسنجان': { en: 'Pistachios', sv: 'Pistagenötter', enQty: '30g', svQty: '30 g' },
  'بادام هندی': { en: 'Cashews', sv: 'Cashewnötter', enQty: '30g', svQty: '30 g' },
  'فندق': { en: 'Hazelnuts', sv: 'Hasselnötter', enQty: '30g', svQty: '30 g' },
  'تخمه آفتابگردان': { en: 'Sunflower Seeds', sv: 'Solroskärnor', enQty: '30g', svQty: '30 g' },
  'تخمه کدو مرمری': { en: 'Pumpkin Seeds', sv: 'Pumpakärnor', enQty: '30g', svQty: '30 g' },
  'کره بادام‌زمینی طبیعی': { en: 'Natural Peanut Butter', sv: 'Naturligt jordnötssmör', enQty: '2 tbsp (30g)', svQty: '2 msk (30 g)' },
  'کنجد بو داده': { en: 'Toasted Sesame Seeds', sv: 'Rostade sesamfrön', enQty: '1 tbsp (15g)', svQty: '1 msk (15 g)' },

  // Grains, Pasta & Potatoes
  'ماکارونی با سس گوشت': { en: 'Persian Style Spaghetti with Minced Meat', sv: 'Persisk makaroni med köttfärssås', enQty: '1 plate (300g)', svQty: '1 tallrik (300 g)' },
  'پاستا آلفردو با مرغ': { en: 'Chicken Alfredo Pasta', sv: 'Kycklingpasta Alfredo', enQty: '1 plate (350g)', svQty: '1 tallrik (350 g)' },
  'سیب‌زمینی آب‌پز': { en: 'Boiled Potatoes', sv: 'Kokt potatis', enQty: '1 large (200g)', svQty: '1 st stor (200 g)' },
  'سیب‌زمینی سرخ‌شده / تنوری': { en: 'Baked / Fried Potato Wedges', sv: 'Ugnsbakad / friterad potatis', enQty: '150g', svQty: '150 g' },
  'نان تافتون': { en: 'Taftoon Flatbread', sv: 'Taftoon-tunnbröd', enQty: '1 bread (100g)', svQty: '1 helt bröd (100 g)' },

  // Vegetables & Salads
  'سالاد فصل با سس': { en: 'Seasonal Salad with Dressing', sv: 'Säsongssallad med dressing', enQty: '1 plate (250g)', svQty: '1 tallrik (250 g)' },
  'کدو سبز پخته': { en: 'Steamed / Sautéed Zucchini', sv: 'Tillagad zucchini', enQty: '150g', svQty: '150 g' },
  'بادمجان کبابی': { en: 'Charcoal Grilled Eggplant', sv: 'Grillad aubergine', enQty: '150g', svQty: '150 g' },
  'لبو / چغندر پخته': { en: 'Cooked Beetroots', sv: 'Kokta rödbetor', enQty: '150g', svQty: '150 g' },
  'ذرت شیرین بخارپز': { en: 'Steamed Sweet Corn', sv: 'Ångkokt sötmajs', enQty: '100g', svQty: '100 g' },

  // Additional Proteins & Traditional Dishes
  'جگر مرغ / گوسفند': { en: 'Chicken / Lamb Liver', sv: 'Kyckling- / Lammlever', enQty: '150g', svQty: '150 g' },
  'پنیر توفو سویا': { en: 'Soy Tofu', sv: 'Sojatofu', enQty: '150g', svQty: '150 g' },
  'آش دوغ اردبیل': { en: 'Ash Doogh (Ardabil Yogurt & Herb Soup)', sv: 'Ash Doogh (ört- & yoghurtsopa)', enQty: '1 bowl (350g)', svQty: '1 skål (350 g)' },
  'حلیم گندم و گوشت': { en: 'Wheat & Shredded Beef Haleem', sv: 'Haleem (vete- & nötköttsgröt)', enQty: '1 bowl (300g)', svQty: '1 skål (300 g)' },
  'شله زرد زعفرانی': { en: 'Sholeh Zard Saffron Rice Pudding', sv: 'Sholeh Zard (persisk saffranspudding)', enQty: '1 bowl (200g)', svQty: '1 skål (200 g)' },
  'فرنی نشاسته / برنج': { en: 'Fereni Rice Flour Pudding', sv: 'Fereni (rismjölspudding)', enQty: '1 bowl (200g)', svQty: '1 skål (200 g)' },
  'شیر برنج خانگی': { en: 'Homemade Rice Pudding (Shir Berenj)', sv: 'Persisk risgrynsgröt (Shir Berenj)', enQty: '1 bowl (250g)', svQty: '1 skål (250 g)' },

  // Beverages & Juices
  'چای سیاه / سبز بدون قند': { en: 'Black / Green Tea (Unsweetened)', sv: 'Svart / Grönt te (osötat)', enQty: '1 cup (200ml)', svQty: '1 kopp (200 ml)' },
  'قهوه اسپرسو / بلک': { en: 'Espresso / Black Coffee', sv: 'Espresso / Svart kaffe', enQty: '1 shot (30ml)', svQty: '1 shot (30 ml)' },
  'کاپوچینو بدون شکر': { en: 'Cappuccino (Unsweetened)', sv: 'Cappuccino (osötad)', enQty: '1 cup (150ml)', svQty: '1 kopp (150 ml)' },
  'آیس لاته کم‌چرب': { en: 'Low-Fat Iced Latte', sv: 'Iced Latte (lättmjölk)', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'آب پرتقال طبیعی': { en: 'Fresh Orange Juice', sv: 'Färskpressad apelsinjuice', enQty: '1 glass (240ml)', svQty: '1 glas (240 ml)' },
  'آب هویج تازه': { en: 'Fresh Carrot Juice', sv: 'Färsk morotsjuice', enQty: '1 glass (240ml)', svQty: '1 glas (240 ml)' },
  'آب سیب طبیعی': { en: 'Fresh Apple Juice', sv: 'Färsk äppeljuice', enQty: '1 glass (240ml)', svQty: '1 glas (240 ml)' },
  'شربت آبلیمو عسل': { en: 'Honey Lemonade Drink', sv: 'Citron- & honungsdryck', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'عرقیات سنتی (کاسنی/بیدمشک)': { en: 'Traditional Herbal Distillate (Chicory/Willow)', sv: 'Traditionellt örtdestillat (Cikoria/Vide)', enQty: '1 glass (250ml)', svQty: '1 glas (250 ml)' },
  'اسموتی پروتئینی موز و شیر': { en: 'Banana & Milk Protein Smoothie', sv: 'Proteinsmoothie med banan & mjölk', enQty: '1 glass (300ml)', svQty: '1 glas (300 ml)' }
};

// Common ingredients and shopping list phrase translation dictionary
const PHRASE_TRANSLATIONS: Record<string, { en: string; sv: string }> = {
  // Common Iranian seasonal ingredients & shopping items
  'سینه و فیله مرغ (۲ کیلو)': { en: 'Chicken breast & tenderloins (2 kg)', sv: 'Kycklingbröst & filé (2 kg)' },
  'گوشت گوساله لخم (۱.۵ کیلو)': { en: 'Lean beef sirloin (1.5 kg)', sv: 'Magert nötkött / oxfilé (1.5 kg)' },
  'فیله ماهی قزل‌آلا/سالمون (۱ کیلو)': { en: 'Trout / Salmon fillets (1 kg)', sv: 'Forell- / Laxfilé (1 kg)' },
  'تخم‌مرغ (۲ شانه‌)': { en: 'Fresh eggs (2 cartons / 60 pcs)', sv: 'Färska ägg (2 kartonger)' },
  'ماست یونانی پرپروتئین (۴ سطل)': { en: 'High-protein Greek yogurt (4 tubs)', sv: 'Proteinrik grekisk yoghurt (4 hinkar)' },
  'برنج ایرانی سبوس‌دار (۵ کیلو)': { en: 'Whole-grain Persian basmati rice (5 kg)', sv: 'Fullkornsbasmatiris (5 kg)' },
  'باقالی تازه (۱.۵ کیلو)': { en: 'Fresh fava beans (1.5 kg)', sv: 'Färska bondbönor (1.5 kg)' },
  'عدس سبز (۱ کیلو)': { en: 'Green lentils (1 kg)', sv: 'Gröna linser (1 kg)' },
  'جو پرک و جو کامل (۱ کیلو)': { en: 'Rolled oats & whole barley (1 kg)', sv: 'Havregryn & helt korn (1 kg)' },
  'لپه و لوبیا چیتی (۱ کیلو)': { en: 'Yellow split peas & pinto beans (1 kg)', sv: 'Gula ärtor & pintobönor (1 kg)' },
  'سبزی خوردن تازه (شاهی، ریحان، نعنا)': { en: 'Fresh Persian herbs (watercress, basil, mint)', sv: 'Färska örter (krasse, basilika, mynta)' },
  'برگ مو تازه': { en: 'Fresh grape leaves', sv: 'Färska vinblad' },
  'کرفس و اسفناج بهاره': { en: 'Spring celery & fresh spinach', sv: 'Selleri & färsk vårspenat' },
  'پیاز بنفش و سیر تازه': { en: 'Red onions & fresh garlic', sv: 'Rödlök & färsk vitlök' },
  'گوجه‌فرنگی و خیار بوته‌ای': { en: 'Fresh tomatoes & cucumbers', sv: 'Färska tomater & gurkor' },
  'روغن زیتون فرابکر (۲ بطری)': { en: 'Extra virgin olive oil (2 bottles)', sv: 'Extra jungfruolivolja (2 flaskor)' },
  'مغز گردو تازه (۵۰۰ گرم)': { en: 'Fresh walnut kernels (500g)', sv: 'Färska valnötskärnor (500 g)' },
  'زردچوبه اعلا قلمی': { en: 'Premium turmeric powder', sv: 'Finmald gurkmeja av hög kvalitet' },
  'فلفل سیاه نیمکوب': { en: 'Cracked black pepper', sv: 'Krossad svartpeppar' },
  'زرشک و رب انار': { en: 'Barberries & pure pomegranate molasses', sv: 'Berberis & ren granatäppelsirap' },
  'سینه مرغ و بوقلمون (۲ کیلو)': { en: 'Chicken & turkey breasts (2 kg)', sv: 'Kyckling- & kalkonbröst (2 kg)' },
  'راسته گوساله (۱.۵ کیلو)': { en: 'Lean beef sirloin (1.5 kg)', sv: 'Oxfilé / Magert nötkött (1.5 kg)' },
  'ماهی تازه (۱.۵ کیلو)': { en: 'Fresh fish fillets (1.5 kg)', sv: 'Färsk fiskfilé (1.5 kg)' },
  'ماست کم‌چرب و یونانی (۵ ظرف)': { en: 'Low-fat & Greek yogurt (5 tubs)', sv: 'Lågfetts- & grekisk yoghurt (5 burkar)' },
  'برنج کته (۴ کیلو)': { en: 'Basmati rice (4 kg)', sv: 'Basmatiris (4 kg)' },
  'کینوا و جو دوسر (۱ کیلو)': { en: 'Quinoa & whole oats (1 kg)', sv: 'Quinoa & havregryn (1 kg)' },
  'لوبیا چیتی و سبز (۲ کیلو)': { en: 'Pinto beans & fresh green beans (2 kg)', sv: 'Pintobönor & haricots verts (2 kg)' },
  'نخود پخته (۱ کیلو)': { en: 'Cooked chickpeas (1 kg)', sv: 'Kokta kikärtor (1 kg)' },
  'بامیه تازه تابستانی (۲ کیلو)': { en: 'Fresh summer okra (2 kg)', sv: 'Färsk sommarokra (2 kg)' },
  'کدو سبز (۲ کیلو)': { en: 'Fresh zucchini (2 kg)', sv: 'Färsk zucchini (2 kg)' },
  'خیار و گوجه فرنگی تازه': { en: 'Fresh cucumbers & tomatoes', sv: 'Färska gurkor & tomater' },
  'لیموترش تازه': { en: 'Fresh lemons & limes', sv: 'Färska citroner & lime' },
  'ریحان و شاهی': { en: 'Fresh basil & watercress', sv: 'Färsk basilika & krasse' },
  'روغن زیتون فرابکر': { en: 'Extra virgin olive oil', sv: 'Extra jungfruolivolja' },
  'گردو خردشده': { en: 'Chopped walnuts', sv: 'Hackade valnötter' },
  'تخم گشنیز و زردچوبه': { en: 'Coriander seeds & turmeric', sv: 'Korianderfrön & gurkmeja' },
  'سماق تبریز': { en: 'Pure sumac spice', sv: 'Ren sumak' },
  'سینه مرغ و فیله (۲ کیلو)': { en: 'Chicken breasts & tenders (2 kg)', sv: 'Kycklingbröst & filéer (2 kg)' },
  'گوشت گوسفندی و گوساله (۲ کیلو)': { en: 'Lean lamb & beef (2 kg)', sv: 'Magert lamm- & nötkött (2 kg)' },
  'ماهی سالمون در فر (۱.۵ کیلو)': { en: 'Salmon fillets (1.5 kg)', sv: 'Laxfiléer (1.5 kg)' },
  'لپه و دال عدس (۲ کیلو)': { en: 'Yellow split peas & red lentils (2 kg)', sv: 'Gula ärtor & röda linser (2 kg)' },
  'برنج ایرانی (۵ کیلو)': { en: 'Persian basmati rice (5 kg)', sv: 'Persiskt basmatiris (5 kg)' },
  'ماش و عدس (۲ کیلو)': { en: 'Mung beans & brown lentils (2 kg)', sv: 'Mungbönor & bruna linser (2 kg)' },
  'کلم قمری/برگ شیرازی': { en: 'Kohlrabi / cabbage', sv: 'Kålrabbi / vitkål' },
  'گندم و جو': { en: 'Whole wheat & barley', sv: 'Fullkornsvete & korn' },
  'اسفناج تازه پاییزی': { en: 'Fresh autumn spinach', sv: 'Färsk höstspenat' },
  'کدو حلوایی': { en: 'Butternut squash / pumpkin', sv: 'Butternutpumpa / pumpa' },
  'هویج و به': { en: 'Carrots & fresh quince', sv: 'Morötter & färsk kvitten' },
  'پیاز و سیر': { en: 'Onions & garlic bulbs', sv: 'Lök & vitlök' },
  'مغز گردو درجه یک (۱.۵ کیلو)': { en: 'Premium walnut kernels (1.5 kg)', sv: 'Förstklassiga valnötskärnor (1.5 kg)' },
  'رب انار طبیعی': { en: 'Pure pomegranate paste / molasses', sv: 'Ren granatäppelsirap' },
  'دارچین و زردچوبه اعلا': { en: 'Ceylon cinnamon & turmeric', sv: 'Ceylonkanel & fin gurkmeja' },
  'گوشت آبگوشتی لخم (۲ کیلو)': { en: 'Lean stewing meat (2 kg)', sv: 'Magert grytkött (2 kg)' },
  'سینه مرغ (۲ کیلو)': { en: 'Chicken breasts (2 kg)', sv: 'Kycklingbröst (2 kg)' },
  'ماهی آزاد/سالمون (۱.۵ کیلو)': { en: 'Wild salmon fillets (1.5 kg)', sv: 'Laxfiléer (1.5 kg)' },
  'ماست و کشک (۴ ظرف)': { en: 'Greek yogurt & kashk whey (4 tubs)', sv: 'Grekisk yoghurt & kashk (4 burkar)' },
  'نخود و لوبیا چیتی/قرمز (۲.۵ کیلو)': { en: 'Chickpeas & pinto/kidney beans (2.5 kg)', sv: 'Kikärtor & pinto-/kidneybönor (2.5 kg)' },
  'عدس و لپه (۲ کیلو)': { en: 'Lentils & yellow split peas (2 kg)', sv: 'Linser & gula ärtor (2 kg)' },
  'جو پرک و جو پوست‌کنده (۱.۵ کیلو)': { en: 'Rolled oats & pearl barley (1.5 kg)', sv: 'Havregryn & korngryn (1.5 kg)' },
  'برنج ایرانی (۴ کیلو)': { en: 'Persian basmati rice (4 kg)', sv: 'Persiskt basmatiris (4 kg)' },
  'اسفناج تازه (۲ کیلو)': { en: 'Fresh spinach (2 kg)', sv: 'Färsk spenat (2 kg)' },
  'چغندر و لبو': { en: 'Beets & red beetroot', sv: 'Rödbetor' },
  'کرفس و قارچ': { en: 'Fresh celery & mushrooms', sv: 'Färsk selleri & champinjoner' },
  'سیر و پیاز بنفش': { en: 'Garlic & red onions', sv: 'Vitlök & rödlök' },
  'مرکبات (لیموترش و نارنج)': { en: 'Citrus (lemons & bitter oranges)', sv: 'Citrusfrukter (citroner & pomerans)' },
  'گردو و دارچین': { en: 'Walnuts & Ceylon cinnamon', sv: 'Valnötter & ceylonkanel' },
  'گلپر': { en: 'Persian hogweed (Golpar) spice', sv: 'Golpar (persisk björnloka krydda)' },

  // Side Dishes & Ingredients
  'سالاد شیرازی': { en: 'Shirazi Salad (cucumber, tomato, onion, olive oil)', sv: 'Shirazi-sallad (gurka, tomat, rödlök, olivolja)' },
  'سالاد شیرازی با روغن زیتون': { en: 'Shirazi Salad with Extra Virgin Olive Oil', sv: 'Shirazi-sallad med extra jungfruolivolja' },
  'سالاد شیرازی با آبغوره و روغن زیتون': { en: 'Shirazi Salad with Verjuice & Extra Virgin Olive Oil', sv: 'Shirazi-sallad med verjuice & olivolja' },
  'سالاد شیرازی و ترشی سیر': { en: 'Shirazi Salad & Pickled Garlic', sv: 'Shirazi-sallad & inlagd vitlök' },
  'سبزی خوردن': { en: 'Fresh Herbs (watercress, mint, radish)', sv: 'Färska persiska örter (krasse, mynta, rädisor)' },
  'سبزی خوردن تازه': { en: 'Fresh Persian Herbs', sv: 'Färska persiska örter (Sabzi Khordan)' },
  'سبزی خوردن و ماست کم‌چرب': { en: 'Fresh Persian Herbs & Low-Fat Yogurt', sv: 'Färska persiska örter & mager yoghurt' },
  'سبزی خوردن و ماست': { en: 'Fresh Persian Herbs & Yogurt', sv: 'Färska persiska örter & yoghurt' },
  'سبزی خوردن و لیمو': { en: 'Fresh Persian Herbs & Lemon', sv: 'Färska persiska örter & citron' },
  'سبزی خوردن و لیموترش': { en: 'Fresh Persian Herbs & Fresh Lemon', sv: 'Färska persiska örter & färsk citron' },
  'سبزی خوردن و خیار': { en: 'Fresh Persian Herbs & Fresh Cucumber', sv: 'Färska persiska örter & gurka' },
  'سبزی خوردن (شاهی فراوان)، سالاد شیرازی با روغن زیتون': { en: 'Fresh Herbs (Watercress) & Shirazi Salad with Olive Oil', sv: 'Färska örter (vattenkrasse) & Shirazi-sallad med olivolja' },
  'سبزی خوردن (شاهی)، سالاد شیرازی': { en: 'Fresh Herbs (Watercress) & Shirazi Salad', sv: 'Färska örter (krasse) & Shirazi-sallad' },
  'سبزی خوردن (شاهی)': { en: 'Fresh Herbs (Watercress)', sv: 'Färska persiska örter (krasse)' },
  'سبزی خوردن (مرزه و ترخون)': { en: 'Fresh Herbs (Savory & Tarragon)', sv: 'Färska örter (kyndel & dragon)' },
  'سبزی خوردن و پیاز': { en: 'Fresh Herbs & Red Onion', sv: 'Färska persiska örter & rödlök' },
  'سبزی خوردن و پیاز بنفش': { en: 'Fresh Herbs & Purple Onion', sv: 'Färska persiska örter & rödlök' },
  'سبزی خوردن و ترشی خانگی': { en: 'Fresh Herbs & Homemade Pickles', sv: 'Färska örter & hemgjord ättiksgurka' },
  'ماست یونانی با پودر گردو، سبزی خوردن': { en: 'Greek Yogurt with Walnuts & Fresh Herbs', sv: 'Grekisk yoghurt med valnötter & färska örter' },
  'ماست یونانی با گردو': { en: 'Greek Yogurt with Walnuts', sv: 'Grekisk yoghurt med valnötter' },
  'ماست یونانی و گردو': { en: 'Greek Yogurt & Walnuts', sv: 'Grekisk yoghurt & valnötter' },
  'ماست یونانی با شوید تازه': { en: 'Greek Yogurt with Fresh Dill', sv: 'Grekisk yoghurt med färsk dill' },
  'ماست و خیار با نعنا و گردو': { en: 'Yogurt & Cucumber with Mint & Walnuts', sv: 'Yoghurtröra med gurka, mynta & valnötter (Mast-o-Khiar)' },
  'ماست و خیار و گردو': { en: 'Yogurt, Cucumber & Walnuts', sv: 'Yoghurt, gurka & valnötter' },
  'ماست و شوید': { en: 'Yogurt with Fresh Dill', sv: 'Yoghurt med färsk dill' },
  'ماست و خرما': { en: 'Greek Yogurt & Dates', sv: 'Grekisk yoghurt & dadlar' },
  'خرما و ماست یونانی': { en: 'Dates & Greek Yogurt', sv: 'Dadlar & grekisk yoghurt' },
  'ریحان تازه، ترشی خانگی بدون شکر': { en: 'Fresh Basil & Sugar-Free Pickles', sv: 'Färsk basilika & sockerfria pickles' },
  'ریحان تازه، سماق و گوجه': { en: 'Fresh Basil, Sumac & Roasted Tomato', sv: 'Färsk basilika, sumak & grillad tomat' },
  'ریحان و گوجه': { en: 'Fresh Basil & Tomatoes', sv: 'Färsk basilika & tomater' },
  'شاهی فراوان (طعم تلخ فعال‌کننده GLP-1)، لیموترش': { en: 'Abundant Watercress (Bitter GLP-1 activator) & Lemon', sv: 'Rikligt med vattenkrasse (GLP-1-aktiverare) & citron' },
  'شاهی فراوان و لیمو': { en: 'Abundant Watercress & Lemon', sv: 'Rikligt med vattenkrasse & citron' },
  'شاهی و گوجه کبابی': { en: 'Watercress & Grilled Tomato', sv: 'Vattenkrasse & grillad tomat' },
  'شاهی و گوجه': { en: 'Watercress & Fresh Tomato', sv: 'Vattenkrasse & tomat' },
  'سیر تازه، لیموترش و سیرترشی': { en: 'Fresh Garlic, Lemon & Pickled Garlic', sv: 'Färsk vitlök, citron & inlagd vitlök' },
  'سیر ترشی و لیموترش': { en: 'Pickled Garlic & Lemon', sv: 'Inlagd vitlök & färsk citron' },
  'سیر ترشی و لیمو': { en: 'Pickled Garlic & Lemon', sv: 'Inlagd vitlök & citron' },
  'سیرداغ زردچوبه‌ای': { en: 'Turmeric Sautéed Garlic', sv: 'Gurkmeja- & vitlöksfräs' },
  'سیرداغ و پیازداغ کم‌روغن با زردچوبه': { en: 'Low-Oil Turmeric Garlic & Onions', sv: 'Mager vitlöks- & lökfräs med gurkmeja' },
  'سیر و لیمو': { en: 'Fresh Garlic & Lemon', sv: 'Färsk vitlök & citron' },
  'سس ماست و سیر تازه': { en: 'Fresh Garlic & Yogurt Sauce', sv: 'Vitlöks- & yoghurtsås' },
  'سس ماست و سیر': { en: 'Garlic Yogurt Sauce', sv: 'Vitlöksyoghurtsås' },
  'پیازداغ کم‌روغن با زردچوبه و فلفل سیاه': { en: 'Low-Oil Onions with Turmeric & Black Pepper', sv: 'Mager lökfräs med gurkmeja & svartpeppar' },
  'پیاز سماق‌زده، گوجه و شاهی': { en: 'Sumac Onions, Tomato & Watercress', sv: 'Sumakmarinerad lök, tomat & krasse' },
  'گوجه‌فرنگی، خیارشور و شاهی تازه': { en: 'Tomato, Pickles & Fresh Watercress', sv: 'Tomat, saltgurka & färsk krasse' },
  'گوجه فرنگی، خیارشور و سبزی': { en: 'Tomato, Pickles & Fresh Herbs', sv: 'Tomat, saltgurka & färska örter' },
  'گوجه فرنگی و سبزی خوردن': { en: 'Fresh Tomato & Persian Herbs', sv: 'Färsk tomat & persiska örter' },
  'گوجه و خیارشور': { en: 'Tomato & Pickles', sv: 'Tomat & saltgurka' },
  'گوجه و سبزی': { en: 'Tomato & Fresh Herbs', sv: 'Tomat & färska örter' },
  'گوجه کبابی و سماق زردچوبه‌دار': { en: 'Grilled Tomato & Turmeric Sumac', sv: 'Grillad tomat & gurkmeja-sumak' },
  'گوجه کبابی و سماق': { en: 'Grilled Tomato & Sumac', sv: 'Grillad tomat & sumak' },
  'گوجه کبابی و فلفل سبز': { en: 'Grilled Tomato & Green Chili', sv: 'Grillad tomat & grön chili' },
  'گوجه کبابی': { en: 'Grilled Tomato', sv: 'Grillad tomat' },
  'زیتون پرورده با گردو': { en: 'Zeytoon Parvardeh (Marinated Olives with Walnuts & Pomegranate)', sv: 'Zeytoon Parvardeh (marinerade oliver med valnötter)' },
  'زیتون پرورده': { en: 'Zeytoon Parvardeh (Marinated Olives)', sv: 'Zeytoon Parvardeh (marinerade oliver)' },
  'زیتون و لیمو': { en: 'Fresh Olives & Lemon', sv: 'Oliver & färsk citron' },
  'لیموترش تازه و سبزی خوردن': { en: 'Fresh Lemon & Persian Herbs', sv: 'Färsk citron & persiska örter' },
  'لیموترش تازه و نان جو': { en: 'Fresh Lemon & Barley Bread', sv: 'Färsk citron & kornbröd' },
  'لیموترش و زیتون': { en: 'Fresh Lemon & Olives', sv: 'Färsk citron & oliver' },
  'لیموترش و زیتون پرورده': { en: 'Fresh Lemon & Zeytoon Parvardeh', sv: 'Färsk citron & marinerade oliver' },
  'لیموترش و گلپر': { en: 'Fresh Lemon & Golpar Spice', sv: 'Färsk citron & golpar-krydda' },
  'لیموترش و گردو خردشده': { en: 'Fresh Lemon & Chopped Walnuts', sv: 'Färsk citron & hackade valnötter' },
  'لیموترش و سیر تازه': { en: 'Fresh Lemon & Garlic', sv: 'Färsk citron & vitlök' },
  'گردو و لیمو': { en: 'Walnuts & Fresh Lemon', sv: 'Valnötter & färsk citron' },
  'نعنا داغ کم‌چرب': { en: 'Low-Fat Sautéed Mint', sv: 'Mager varm myntaolja' },
  'نعنا داغ و گردو': { en: 'Sautéed Mint & Walnuts', sv: 'Varm myntaolja & valnötter' },
  'نعنا داغ': { en: 'Sautéed Mint Oil', sv: 'Varm myntaolja' },
  'سالاد فصل با روغن زیتون': { en: 'Garden Salad with Extra Virgin Olive Oil', sv: 'Säsongssallad med extra jungfruolivolja' },
  'سالاد کاهو با سرو روغن زیتون': { en: 'Lettuce Salad with Olive Oil', sv: 'Kruksallad med olivolja' },
  'سالاد کاهو': { en: 'Fresh Green Salad', sv: 'Grönsallad' },
  'ترشی، سبزی خوردن و پیاز بنفش': { en: 'Pickles, Fresh Herbs & Purple Onion', sv: 'Pickles, färska örter & rödlök' },
  'ترشی مخلوط و سبزی': { en: 'Mixed Pickles & Fresh Herbs', sv: 'Blandade pickles & färska örter' },
  'خیارشور و جعفری تازه': { en: 'Pickles & Fresh Parsley', sv: 'Saltgurka & färsk persilja' },
  'خیارشور و جعفری': { en: 'Pickles & Parsley', sv: 'Saltgurka & persilja' },
  'جعفری تازه': { en: 'Fresh Parsley', sv: 'Färsk persilja' },
  'سبزی و ترشی': { en: 'Fresh Herbs & Pickles', sv: 'Färska örter & pickles' },
  'نان جو و جعفری تازه': { en: 'Barley Bread & Fresh Parsley', sv: 'Kornbröd & färsk persilja' },

  'بادمجان کبابی تنوری (کم‌روغن)': { en: 'Oven-roasted eggplant (low oil)', sv: 'Ugnsrostad aubergine (låg olja)' },
  'بادمجان کبابی تنوری': { en: 'Oven-roasted eggplant', sv: 'Ugnsrostad aubergine' },
  'گوشت لخم گوساله': { en: 'Lean beef sirloin', sv: 'Magert nötkött' },
  'گوجه و ۸ق برنج': { en: 'Tomato & 8 tbsp basmati rice', sv: 'Tomat & 8 msk basmatiris' },
  'بادمجان کباب شده': { en: 'Roasted eggplant', sv: 'Ugnsrostad aubergine' },
  'گوشت لخم': { en: 'Lean meat', sv: 'Magert kött' },
  'گوجه': { en: 'Tomato', sv: 'Tomat' },
  'برنج': { en: 'Basmati rice', sv: 'Basmatiris' },
  'برنج کته': { en: 'Steamed basmati rice', sv: 'Basmatiris' },
  'ماست کم‌چرب': { en: 'Low-fat yogurt', sv: 'Mager yoghurt' },
  'ماست': { en: 'Yogurt', sv: 'Yoghurt' },
  'ماست کم چرب': { en: 'Low-fat yogurt', sv: 'Mager yoghurt' },

  // Recipe Ingredients
  'بادمجان کبابی تنوری (کم‌روغن) + گوشت لخم گوساله + گوجه و ۸ق برنج': {
    en: 'Oven-roasted eggplant (low oil) + lean beef sirloin + tomato & 8 tbsp basmati rice',
    sv: 'Ugnsrostad aubergine (låg olja) + magert nötkött + tomat & 8 msk basmatiris'
  },
  'سینه مرغ + برنج کته با باقالی تازه و شوید + زردچوبه و روغن زیتون': {
    en: 'Chicken breast + steamed rice with fresh fava beans & dill + turmeric & olive oil',
    sv: 'Kycklingbröst + basmatiris med färska bondbönor & dill + gurkmeja & olivolja'
  },
  'گوشت لخم گوسفندی/گوساله + سبزی قورمه تازه (شنبلیله و جعفری) + لیمو عمانی': {
    en: 'Lean beef/lamb + fresh Ghormeh herbs (fenugreek & parsley) + dried lime',
    sv: 'Magert nötkött/lamm + färska Ghormeh-örter (bockhornsklöver & persilja) + torkad lime'
  },
  'گوشت چرخ‌کرده کم‌چرب + پیاز رنده‌شده + زردچوبه و فلفل + گوجه کبابی': {
    en: 'Lean ground beef + grated onion + turmeric & black pepper + grilled tomato',
    sv: 'Mager nötfärs + riven lök + gurkmeja & svartpeppar + grillad tomat'
  },
  'جو پوست‌کنده + نخود و عدس + سبزی آش + کشک کم‌چرب + زردچوبه': {
    en: 'Pearl barley + chickpeas & lentils + fresh soup herbs + low-fat whey + turmeric',
    sv: 'Korn + kikärtor & linser + soppörter + mager kashk + gurkmeja'
  },
  'فیله مرغ زعفرانی خوابانده در ماست + زردچوبه + ۶ق برنج': {
    en: 'Saffron chicken tenders marinated in yogurt + turmeric + 6 tbsp basmati rice',
    sv: 'Saffransmarinerad kycklingfilé i yoghurt + gurkmeja + 6 msk basmatiris'
  },
  'برگ مو تازه + گوشت چرخ‌کرده + لپه و برنج + سبزی دلمه + زردچوبه': {
    en: 'Fresh grape leaves + ground beef + split peas & rice + dolma herbs + turmeric',
    sv: 'Färska vinblad + nötfärs + gula ärtor & ris + dolma-örter + gurkmeja'
  },
  'فیله ماهی قزل‌آلا/سالمون کباب‌شده + سبزی پلو تازه با سیر': {
    en: 'Grilled trout/salmon fillet + fresh herb rice with garlic',
    sv: 'Grillad lax-/forellfilé + färskt örtris med vitlök'
  },
  'برنج کته کم‌چرب + ماست یونانی پرپروتئین + مغز گردو + نعنا و زردچوبه': {
    en: 'Basmati rice + high-protein Greek yogurt + walnut halves + mint & turmeric',
    sv: 'Basmatiris + proteinrik grekisk yoghurt + valnötskärnor + mynta & gurkmeja'
  },
  'ساقه‌های کرفس تازه + نعنا و جعفری + گوشت گوساله لخم + ۸ق برنج': {
    en: 'Fresh celery stalks + mint & parsley + lean beef sirloin + 8 tbsp basmati rice',
    sv: 'Färsk selleri + mynta & persilja + magert nötkött + 8 msk basmatiris'
  },
  'برنج کته + عدس سبز فراوان + گوشت چرخ‌کرده کم‌چرب + دارچین و زردچوبه': {
    en: 'Basmati rice + abundant green lentils + lean ground beef + cinnamon & turmeric',
    sv: 'Basmatiris + rikligt med gröna linser + mager nötfärs + kanel & gurkmeja'
  },
  'سبزی کوکو تازه + تخم‌مرغ + گردو خردشده + زرشک + نان سنگک': {
    en: 'Fresh Kuku herbs + organic eggs + chopped walnuts + barberries + Sangak bread',
    sv: 'Färska örtomelett-örter + ägg + hackade valnötter + berberis + Sangak-bröd'
  },
  'ران/سینه مرغ + رب انار ترش + سبزیجات معطر محلی + گردو آسیاب‌شده + ۶ق برنج': {
    en: 'Chicken breast/thigh + sour pomegranate molasses + local herbs + ground walnuts + 6 tbsp rice',
    sv: 'Kycklingbröst/lår + syrlig granatäppelsirap + aromatiska örter + malda valnötter + 6 msk ris'
  },
  'لوبیا چیتی پخته + قارچ اسلایس شده + رب گوجه + گلپر + روغن زیتون': {
    en: 'Cooked pinto beans + sliced mushrooms + tomato paste + Golpar spice + olive oil',
    sv: 'Kokta pintobönor + skivade champinjoner + tomatpuré + golpar-krydda + olivolja'
  },
  'گوشت گوساله تکه‌ای + پیاز و فلفل دلمه‌ای سیخ چوبی + گوجه و زردچوبه': {
    en: 'Diced beef sirloin + onion & bell pepper skewers + tomato & turmeric',
    sv: 'Tärnad oxfilé + spett med lök & paprika + tomat & gurkmeja'
  },
  'گوشت گوساله پخته + برنج باقالی با شوید تازه + زردچوبه و روغن زیتون': {
    en: 'Tender beef + fava bean rice with fresh dill + turmeric & olive oil',
    sv: 'Mört nötkött + bondböneris med färsk dill + gurkmeja & olivolja'
  },
  'سبزی قورمه تازه + لوبیا قرمز + گوشت لخم + برنج کته': {
    en: 'Fresh Ghormeh herbs + red kidney beans + lean beef + basmati rice',
    sv: 'Färska Ghormeh-örter + röda kidneybönor + magert nötkött + basmatiris'
  },
  'گوشت بوقلمون چرخ‌کرده + زردچوبه و فلفل + روغن زیتون + برنج': {
    en: 'Ground turkey + turmeric & black pepper + olive oil + basmati rice',
    sv: 'Kalkonfärs + gurkmeja & svartpeppar + extra jungfruolivolja + basmatiris'
  },
  'جو پرک و سالم + حبوبات + سبزی آش + کشک': {
    en: 'Rolled & whole barley + mixed legumes + soup herbs + whey',
    sv: 'Korn & havre + baljväxter + soppörter + kashk'
  },
  'فیله مرغ گریل زعفرانی + برنج کته': {
    en: 'Grilled saffron chicken tenderloins + basmati rice',
    sv: 'Grillad saffranskycklingfilé + basmatiris'
  },
  'برگ مو تازه + لپه، گوشت و برنج + زردچوبه': {
    en: 'Fresh grape leaves + split peas, minced meat & rice + turmeric',
    sv: 'Färska vinblad + gula ärtor, köttfärs & ris + gurkmeja'
  },
  'ماهی قزل‌آلا کامل تنوری + سبزی پلو شوید دار': {
    en: 'Whole baked trout + dill herb rice',
    sv: 'Hel ugnsbakad forell + dill- & örtris'
  },
  'کته برنج ایرانی + ماست یونانی + گردو و نعنا': {
    en: 'Steamed Persian rice + Greek yogurt + walnuts & mint',
    sv: 'Persiskt basmatiris + grekisk yoghurt + valnötter & mynta'
  },
  'کرفس تازه + سینه مرغ + آبغوره و زردچوبه + ۸ق برنج': {
    en: 'Fresh celery + chicken breast + verjuice & turmeric + 8 tbsp basmati rice',
    sv: 'Färsk selleri + kycklingbröst + verjuice & gurkmeja + 8 msk basmatiris'
  },
  'عدس سبز فراوان + گوشت چرخ‌کرده + کشمش کم': {
    en: 'Abundant green lentils + lean ground beef + light raisins',
    sv: 'Rikligt med gröna linser + mager nötfärs + lite russin'
  },
  'سبزی کوکو + زرشک + گردو + نان سنگک': {
    en: 'Herb frittata + barberries + walnuts + Sangak bread',
    sv: 'Örtomelett + berberis + valnötter + Sangak-bröd'
  },
  'مرغ + رب انار + سبزیجات معطر + گردو + ۶ق برنج': {
    en: 'Chicken + pomegranate molasses + herbs + walnuts + 6 tbsp rice',
    sv: 'Kyckling + granatäppelsirap + örter + valnötter + 6 msk ris'
  },
  'لوبیا چیتی + قارچ + گلپر + روغن زیتون': {
    en: 'Pinto beans + mushrooms + Golpar + extra virgin olive oil',
    sv: 'Pintobönor + champinjoner + golpar-krydda + olivolja'
  },
  'راسته گوساله + فلفل دلمه‌ای و پیاز + ۶ق برنج': {
    en: 'Beef sirloin + bell peppers & onion + 6 tbsp basmati rice',
    sv: 'Oxfilé + paprika & lök + 6 msk basmatiris'
  },
  'بامیه تازه + گوشت تکه‌ای گوساله + سیر و گوجه + زردچوبه + ۸ق برنج': {
    en: 'Fresh okra + diced beef sirloin + garlic & tomato + turmeric + 8 tbsp rice',
    sv: 'Färsk okra + tärnat nötkött + vitlök & tomat + gurkmeja + 8 msk basmatiris'
  },
  'لوبیا سبز تازه + گوشت تکه‌ای + رب گوجه و زردچوبه و دارچین + برنج': {
    en: 'Fresh green beans + diced beef + tomato paste, turmeric & cinnamon + rice',
    sv: 'Färska gröna bönor + nötkött + tomatpuré, gurkmeja & kanel + basmatiris'
  },
  'ماست یونانی + خیار رنده‌شده + گردو + کشمش + کشک + نان سنگک خشک': {
    en: 'Greek yogurt + grated cucumber + walnuts + raisins + whey + crisp Sangak',
    sv: 'Grekisk yoghurt + riven gurka + valnötter + russin + kashk + krispigt Sangak-bröd'
  },
  'کدو سبز تنوری با آرد سبوس‌دار + فیله مرغ گریل + زردچوبه و فلفل': {
    en: 'Baked zucchini with whole flour crust + grilled chicken tenders + turmeric & pepper',
    sv: 'Ugnsrostad zucchini med fullkornsmjöl + grillad kycklingfilé + gurkmeja & peppar'
  },
  'فیله مرغ خوابانده در ماست، تخم گشنیز و لیمو + ۶ق برنج': {
    en: 'Chicken tenders marinated in yogurt, coriander seeds & lemon + 6 tbsp rice',
    sv: 'Kycklingfilé marinerad i yoghurt, korianderfrön & citron + 6 msk ris'
  },
  'برنج کته + گوجه تازه + لوبیا سبز + فیله مرغ تکه‌ای + زردچوبه': {
    en: 'Basmati rice + fresh tomatoes + green beans + diced chicken fillet + turmeric',
    sv: 'Basmatiris + färska tomater + gröna bönor + tärnad kycklingfilé + gurkmeja'
  },
  'ماهی قزل‌آلا/سالمون کبابی با زردچوبه و فلفل سیاه + سبزیجات تنوری': {
    en: 'Grilled trout/salmon with turmeric & black pepper + roasted garden veggies',
    sv: 'Grillad lax/forell med gurkmeja & svartpeppar + ugnsrostade grönsaker'
  },
  'ماست یونانی + زرده تخم‌مرغ + زرشک + سینه مرغ زعفرانی + برنج': {
    en: 'Greek yogurt + egg yolk + barberries + saffron chicken breast + rice (Tahchin)',
    sv: 'Grekisk yoghurt + äggula + berberis + saffranskycklingbröst + basmatiris (Tahchin)'
  },
  'گوشت بوقلمون چرخ‌کرده + زردچوبه و فلفل سیاه + گوجه کبابی + ۶ق برنج': {
    en: 'Ground turkey + turmeric & black pepper + grilled tomato + 6 tbsp rice',
    sv: 'Mald kalkonfärs + gurkmeja & svartpeppar + grillad tomat + 6 msk basmatiris'
  },
  'ریواس/گوجه سبز ترش + نعنا و جعفری + گوشت لخم + ۸ق برنج': {
    en: 'Sour rhubarb / green plum + mint & parsley + lean beef + 8 tbsp rice',
    sv: 'Syrlig rabarber / gröna plommon + mynta & persilja + magert nötkött + 8 msk ris'
  },
  'کینوا پخته + فیله مرغ گریل + زیتون سبز + کاهو + روغن زیتون': {
    en: 'Cooked quinoa + grilled chicken fillet + green olives + lettuce + extra virgin olive oil',
    sv: 'Kokt quinoa + grillad kycklingfilé + gröna oliver + krispsallad + olivolja'
  },
  'سینه مرغ بخارپز + کدو، هویج، قارچ و بروکلی + نان جو': {
    en: 'Steamed chicken breast + zucchini, carrots, mushrooms & broccoli + barley bread',
    sv: 'Ångkokt kycklingbröst + zucchini, morötter, champinjoner & broccoli + kornbröd'
  },
  'راسته گوساله خوابانده در ماست و روغن زیتون + ۶ق برنج زعفرانی': {
    en: 'Beef sirloin marinated in yogurt & olive oil + 6 tbsp saffron rice',
    sv: 'Oxfilé marinerad i yoghurt & olivolja + 6 msk saffransris'
  },
  'بامیه + گوشت تکه‌ای + سیر و گوجه + برنج کته': {
    en: 'Okra + diced beef + garlic & tomato + basmati rice',
    sv: 'Okra + tärnat nötkött + vitlök & tomat + basmatiris'
  },
  'لوبیا سبز + برنج کته + گوشت لخم + دارچین و زردچوبه': {
    en: 'Green beans + basmati rice + lean beef + cinnamon & turmeric',
    sv: 'Gröna bönor + basmatiris + magert nötkött + kanel & gurkmeja'
  },
  'ماست یونانی + خیار + گردو + نان سنگک خشک': {
    en: 'Greek yogurt + cucumber + walnuts + crisp Sangak bread',
    sv: 'Grekisk yoghurt + gurka + valnötter + krispigt Sangak-bröd'
  },
  'کدو سبز + فیله مرغ گریل + زردچوبه و فلفل': {
    en: 'Zucchini + grilled chicken breast + turmeric & pepper',
    sv: 'Zucchini + grillat kycklingbröst + gurkmeja & peppar'
  },
  'مرغ خوابانده در ماست + ۶ق برنج': {
    en: 'Yogurt marinated chicken + 6 tbsp basmati rice',
    sv: 'Yoghurtmarinerad kyckling + 6 msk basmatiris'
  },
  'گوجه فرنگی + برنج + لوبیا سبز + فیله مرغ': {
    en: 'Tomato + basmati rice + green beans + chicken fillet',
    sv: 'Tomat + basmatiris + gröna bönor + kycklingfilé'
  },
  'فیله ماهی + سبزیجات تنوری + لیموترش': {
    en: 'Fish fillet + roasted veggies + fresh lemon',
    sv: 'Fiskfilé + ugnsrostade grönsaker + färsk citron'
  },
  'بادمجان کباب شده + گوشت لخم + گوجه + برنج': {
    en: 'Roasted eggplant + lean beef + tomato + basmati rice',
    sv: 'Ugnsrostad aubergine + magert nötkött + tomat + basmatiris'
  },
  'ماست یونانی + زرشک + سینه مرغ زعفرانی': {
    en: 'Greek yogurt + barberries + saffron chicken breast',
    sv: 'Grekisk yoghurt + berberis + saffranskycklingbröst'
  },
  'بوقلمون چرخ‌کرده + گوجه کبابی + برنج': {
    en: 'Ground turkey + grilled tomato + basmati rice',
    sv: 'Kalkonfärs + grillad tomat + basmatiris'
  },
  'گوجه سبز ترش + سبزی معطر + مرغ + برنج': {
    en: 'Sour green plum + aromatic herbs + chicken + rice',
    sv: 'Gröna plommon + aromatiska örter + kyckling + basmatiris'
  },
  'کینوا + مرغ گریل + زیتون + روغن زیتون': {
    en: 'Quinoa + grilled chicken + olives + extra virgin olive oil',
    sv: 'Quinoa + grillad kyckling + oliver + extra jungfruolivolja'
  },
  'مرغ پخته + کدو + قارچ + نان جو': {
    en: 'Cooked chicken + zucchini + mushrooms + barley bread',
    sv: 'Kokt kyckling + zucchini + champinjoner + kornbröd'
  },
  'راسته گوساله + برنج زعفرانی + پیاز و سماق': {
    en: 'Beef sirloin + saffron rice + sumac onions',
    sv: 'Oxfilé + saffransris + sumakmarinerad lök'
  },
  'گردو فراوان آسیاب‌شده + رب انار ترش + سینه/فیله مرغ + ۶ تا ۸ق برنج': {
    en: 'Finely ground walnuts + sour pomegranate molasses + chicken fillet + 6-8 tbsp rice',
    sv: 'Finmalda valnötter + syrlig granatäppelsirap + kycklingfilé + 6-8 msk basmatiris'
  },
  'هویج رنده‌شده زعفرانی + فیله مرغ + خلال بادام + برنج کته': {
    en: 'Saffron grated carrots + chicken tenders + slivered almonds + basmati rice',
    sv: 'Saffransrivna morötter + kycklingfilé + mandelspån + basmatiris'
  },
  'کلم قمری/برگ خردشده + سبزی معطر (ترخون و ریحان) + کوفته قلقلی گوشت': {
    en: 'Chopped kohlrabi/cabbage + herbs (tarragon & basil) + lean beef meatballs',
    sv: 'Strimlad kålrabbi/kål + örter (dragon & basilika) + köttbullar'
  },
  'عدس سبز غلیظ + پیازداغ با زردچوبه فراوان + روغن زیتون + نان سنگک': {
    en: 'Hearty green lentils + turmeric sautéed onions + olive oil + Sangak bread',
    sv: 'Fylliga gröna linser + gurkmejalök + olivolja + Sangak-bröd'
  },
  'به پاییزی اسلایس‌شده + آلو بخارا + گوشت گوسفندی لخم + ۸ق برنج': {
    en: 'Sliced autumn quince + Bukhara prunes + lean lamb + 8 tbsp basmati rice',
    sv: 'Skivad höstkvitten + Bukhara-plommon + magert lammkött + 8 msk basmatiris'
  },
  'سیب‌زمینی پخته + گوشت چرخ‌کرده + زردچوبه و فلفل در فر (بدون روغن) + نان': {
    en: 'Boiled potatoes + minced beef + turmeric & pepper (oven-baked, no oil) + bread',
    sv: 'Potatis + nötfärs + gurkmeja & peppar (ugnsbakad, oljefri) + bröd'
  },
  'گوشت گوسفندی/گوساله لخم چرخ‌کرده + زردچوبه و فلفل سیاه + ۸ق برنج': {
    en: 'Lean ground beef/lamb + turmeric & black pepper + 8 tbsp basmati rice',
    sv: 'Mager lamm-/nötfärs + gurkmeja & svartpeppar + 8 msk basmatiris'
  },
  'اسفناج تازه پاییزی فراوان + آلو بخارا + گوشت تکه‌ای + ۸ق برنج': {
    en: 'Abundant autumn spinach + Bukhara prunes + diced beef + 8 tbsp basmati rice',
    sv: 'Färsk höstspenat + Bukhara-plommon + tärnat nötkött + 8 msk basmatiris'
  },
  'مرغ شکم‌پر با گردو خردشده، رب انار و زرشک + ۶ق برنج': {
    en: 'Stuffed roast chicken with chopped walnuts, pomegranate molasses & barberries + 6 tbsp rice',
    sv: 'Ugnsstekt kyckling fylld med valnötter, granatäpple & berberis + 6 msk ris'
  },
  'ماش پخته + برنج کته شویددار + گوشت تکه‌ای یا چرخ‌کرده + زردچوبه': {
    en: 'Cooked mung beans + dill basmati rice + diced/minced beef + turmeric',
    sv: 'Mungbönor + dillkryddat basmatiris + nötkött + gurkmeja'
  },
  'کدو حلوایی تنوری + دارچین + گوشت گوساله پخته + نان جو': {
    en: 'Baked butternut squash + Ceylon cinnamon + tender beef + barley bread',
    sv: 'Ugnsbakad pumpa + ceylonkanel + mört nötkött + kornbröd'
  },
  'دال عدس تند + سیر و زردچوبه فراوان + تمر هندی + ۶ق برنج': {
    en: 'Spicy red lentils + garlic & turmeric + tamarind paste + 6 tbsp basmati rice',
    sv: 'Kryddiga röda linser + rikligt med vitlök & gurkmeja + tamarind + 6 msk ris'
  },
  'لپه پخته + گوشت پخته ریش‌ریش + تخم‌مرغ + زردچوبه + نان سنگک': {
    en: 'Cooked split peas + shredded beef + eggs + turmeric + Sangak bread (Shami Pook)',
    sv: 'Gula ärtor + strimlat nötkött + ägg + gurkmeja + Sangak-bröd (Shami Pook)'
  },
  'فیله سالمون تنوری با زردچوبه، سیر و فلفل سیاه + سبزیجات پاییزی': {
    en: 'Baked salmon with turmeric, garlic & pepper + autumn roasted vegetables',
    sv: 'Ugnsbakad lax med gurkmeja, vitlök & svartpeppar + rostade höstgrönsaker'
  },
  'گردو آسیاب شده + رب انار + مرغ + ۶ق برنج': {
    en: 'Ground walnuts + pomegranate molasses + chicken + 6 tbsp rice',
    sv: 'Malda valnötter + granatäppelsirap + kyckling + 6 msk basmatiris'
  },
  'هویج + برنج کته + فیله مرغ + خلال بادام': {
    en: 'Carrots + basmati rice + chicken fillet + slivered almonds',
    sv: 'Morötter + basmatiris + kycklingfilé + mandelspån'
  },
  'کلم قمری + سبزی ترخون و ریحان + کوفته قلقلی': {
    en: 'Kohlrabi + tarragon & basil + meatballs',
    sv: 'Kålrabbi + dragon & basilika + köttbullar'
  },
  'عدس سبز + پیازداغ زردچوبه‌ای + روغن زیتون + نان': {
    en: 'Green lentils + turmeric onions + olive oil + bread',
    sv: 'Gröna linser + gurkmejalök + olivolja + fullkornsbröd'
  },
  'به پاییزی + آلو + گوشت گوساله + برنج': {
    en: 'Autumn quince + plums + beef + basmati rice',
    sv: 'Höstkvitten + plommon + nötkött + basmatiris'
  },
  'گوشت چرخ‌کرده + سیب‌زمینی + نان سنگک': {
    en: 'Minced beef + baked potatoes + Sangak bread',
    sv: 'Nötfärs + ugnsbakad potatis + Sangak-bröd'
  },
  'گوشت چرخ‌کرده لخم + برنج زعفرانی + سماق': {
    en: 'Lean ground beef + saffron rice + sumac',
    sv: 'Mager nötfärs + saffransris + sumak'
  },
  'اسفناج فراوان + آلو بخارا + گوشت + ۸ق برنج': {
    en: 'Spinach + Bukhara prunes + beef + 8 tbsp rice',
    sv: 'Färsk spenat + Bukhara-plommon + nötkött + 8 msk ris'
  },
  'مرغ شکم‌پر + گردو + رب انار + برنج': {
    en: 'Stuffed chicken + walnuts + pomegranate molasses + rice',
    sv: 'Fylld kyckling + valnötter + granatäppelsirap + basmatiris'
  },
  'ماش + شوید + گوشت تکه‌ای + برنج کته': {
    en: 'Mung beans + dill + beef + basmati rice',
    sv: 'Mungbönor + dill + nötkött + basmatiris'
  },
  'کدو حلوایی + گوشت + دارچین + نان جو': {
    en: 'Butternut squash + beef + cinnamon + barley bread',
    sv: 'Pumpa + nötkött + kanel + kornbröd'
  },
  'دال عدس + سیر و تمر هندی + برنج': {
    en: 'Red lentils + garlic & tamarind + basmati rice',
    sv: 'Röda linser + vitlök & tamarind + basmatiris'
  },
  'لپه + گوشت + تخم‌مرغ + نان سنگک': {
    en: 'Split peas + beef + eggs + Sangak bread',
    sv: 'Gula ärtor + nötkött + ägg + Sangak-bröd'
  },
  'سالمون تنوری + سبزیجات پاییزی': {
    en: 'Baked salmon + roasted autumn vegetables',
    sv: 'Ugnsbakad lax + rostade höstgrönsaker'
  },
  'نخود، عدس و لوبیا چیتی + سبزی آش فراوان + کشک کم‌چرب + زردچوبه': {
    en: 'Chickpeas, lentils & pinto beans + soup herbs + low-fat whey + turmeric',
    sv: 'Kikärtor, linser & pintobönor + soppörter + mager kashk + gurkmeja'
  },
  'لپه فراوان + گوشت لخم گوساله + لیمو عمانی + زردچوبه + ۸ق برنج': {
    en: 'Split peas + lean beef sirloin + dried lime + turmeric + 8 tbsp basmati rice',
    sv: 'Gula ärtor + magert nötkött + torkad lime + gurkmeja + 8 msk basmatiris'
  },
  'جو پوست‌کنده + فیله مرغ ریش‌ریش + هویج، کرفس و جعفری + زردچوبه': {
    en: 'Pearl barley + shredded chicken + carrots, celery & parsley + turmeric',
    sv: 'Korn + strimlad kyckling + morötter, selleri & persilja + gurkmeja'
  },
  'گوشت لخم آبگوشتی + نخود و لوبیا + گوجه و لیمو عمانی + نان سنگک': {
    en: 'Lean stewing meat + chickpeas & beans + tomato & dried lime + Sangak bread',
    sv: 'Magert grytkött + kikärtor & bönor + tomat & torkad lime + Sangak-bröd'
  },
  'اسفناج تازه فراوان + ۲ عدد تخم‌مرغ + سیر تازه و زردچوبه + نان سنگک': {
    en: 'Fresh spinach + 2 eggs + fresh garlic & turmeric + Sangak bread (Nargesi)',
    sv: 'Färsk spenat + 2 ägg + färsk vitlök & gurkmeja + Sangak-bröd (Nargesi)'
  },
  'کدو سبز + آلو بخارا + گوشت تکه‌ای گوساله + زردچوبه + ۸ق برنج': {
    en: 'Zucchini + Bukhara prunes + diced beef + turmeric + 8 tbsp basmati rice',
    sv: 'Zucchini + Bukhara-plommon + tärnat nötkött + gurkmeja + 8 msk basmatiris'
  },
  'فیله ماهی قزل‌آلا/سالمون + سبزی پلو تازه با سیر فراوان': {
    en: 'Trout/salmon fillet + fresh herb rice with garlic',
    sv: 'Lax-/forellfilé + färskt örtris med rikligt med vitlök'
  },
  'جو پرک + شیر کم‌چرب + قارچ اسلایس شده + فیله مرغ + زردچوبه': {
    en: 'Rolled oats + low-fat milk + sliced mushrooms + chicken fillet + turmeric',
    sv: 'Havregryn + lättmjölk + champinjoner + kycklingfilé + gurkmeja'
  },
  'گوشت تکه‌ای گوساله + به زمستانی + هویج، سیب‌زمینی و پیاز + نان سنگک': {
    en: 'Diced beef + winter quince + carrots, potatoes & onion + Sangak bread (Tas Kebab)',
    sv: 'Tärnat nötkött + vinterkvitten + morötter, potatis & lök + Sangak-bröd (Tas Kebab)'
  },
  'گوشت لخم گوساله/زبان پخته + سس قارچ و زردچوبه + نان سنگک': {
    en: 'Cooked lean beef / tongue + mushroom turmeric sauce + Sangak bread',
    sv: 'Kokt magert nötkött / tunga + champinjonsås med gurkmeja + Sangak-bröd'
  },
  'لپه پخته + گردو + آلو + گوشت چرخ‌کرده کم‌چرب + نان سنگک': {
    en: 'Cooked split peas + walnuts + prunes + lean ground beef + Sangak bread (Kofteh)',
    sv: 'Kokta gula ärtor + valnötter + plommon + mager nötfärs + Sangak-bröd (Kofteh)'
  },
  'لپه + سینه مرغ + رب گوجه و زردچوبه و دارچین + ۸ق برنج': {
    en: 'Split peas + chicken breast + tomato paste, turmeric & cinnamon + 8 tbsp rice',
    sv: 'Gula ärtor + kycklingbröst + tomatpuré, gurkmeja & kanel + 8 msk basmatiris'
  },
  'بادمجان + عدس + گوشت کش‌دار + کشک کم‌چرب + نان سنگک': {
    en: 'Eggplant + lentils + shredded beef + low-fat whey + Sangak bread (Haleem Bademjan)',
    sv: 'Aubergine + linser + strimlat nötkött + mager kashk + Sangak-bröd (Haleem Bademjan)'
  },
  'سینه مرغ گریل + کلم بروکلی بخارپز + روغن زیتون و لیمو': {
    en: 'Grilled chicken breast + steamed broccoli + extra virgin olive oil & lemon',
    sv: 'Grillat kycklingbröst + ångkokt broccoli + extra jungfruolivolja & citron'
  },
  'حبوبات کامل + سبزی آش + کشک کم‌چرب': {
    en: 'Whole legumes + Ash herbs + low-fat kashk whey',
    sv: 'Blandade baljväxter + soppörter + mager kashk'
  },
  'لپه + گوشت لخم + لیمو عمانی + برنج': {
    en: 'Split peas + lean beef + dried lime + basmati rice',
    sv: 'Gula ärtor + magert nötkött + torkad lime + basmatiris'
  },
  'مرغ ریش‌ریش + جو + هویج و کرفس': {
    en: 'Shredded chicken + barley + carrots & celery',
    sv: 'Strimlad kyckling + korngryn + morötter & selleri'
  },
  'گوشت آبگوشتی + نخود و لوبیا + نان سنگک': {
    en: 'Stewing meat + chickpeas & beans + Sangak bread',
    sv: 'Grytkött + kikärtor & bönor + Sangak-bröd'
  },
  'اسفناج + تخم‌مرغ + سیر + نان': {
    en: 'Spinach + organic egg + garlic + bread',
    sv: 'Spenat + ekologiskt ägg + vitlök + fullkornsbröd'
  },
  'کدو + آلو + گوشت گوساله + برنج': {
    en: 'Zucchini + plums + lean beef + basmati rice',
    sv: 'Zucchini + plommon + nötkött + basmatiris'
  },
  'ماهی سالمون + سبزی پلو با سیر': {
    en: 'Salmon fillet + herb rice with garlic',
    sv: 'Laxfilé + örtkryddat ris med vitlök'
  },
  'جو پرک + شیر + قارچ + مرغ': {
    en: 'Rolled oats + milk + mushrooms + chicken',
    sv: 'Havregryn + mjölk + champinjoner + kyckling'
  },
  'گوشت + به + هویج + نان سنگک': {
    en: 'Lean meat + quince + carrots + Sangak bread',
    sv: 'Magert kött + kvitten + morötter + bröd'
  },
  'گوشت لخم + سس قارچ + نان': {
    en: 'Lean beef sirloin + mushroom sauce + bread',
    sv: 'Oxfilé / Magert kött + svampsås + fullkornsbröd'
  },
  'لپه + گردو + گوشت + آلو + نان': {
    en: 'Split peas + walnuts + meat + plums + bread',
    sv: 'Gula ärtor + valnötter + nötkött + plommon + bröd'
  },
  'لپه + سینه مرغ + برنج کته': {
    en: 'Split peas + chicken breast + basmati rice',
    sv: 'Gula ärtor + kycklingbröst + basmatiris'
  },
  'بادمجان + عدس + گوشت + کشک': {
    en: 'Eggplant + lentils + lean beef + kashk',
    sv: 'Aubergine + linser + nötkött + kashk'
  },
  'مرغ گریل + بروکلی + روغن زیتون': {
    en: 'Grilled chicken + broccoli + olive oil',
    sv: 'Grillad kyckling + broccoli + extra jungfruolivolja'
  },
  'قهوه سرد + ۱۵۰گ ماست یونانی + ۱۰گ گردو + ۱ ق‌چ دانه چیا + زردچوبه و روغن زیتون': {
    en: 'Cold brew + 150g Greek yogurt + 10g walnuts + 1 tsp chia seeds + turmeric & olive oil',
    sv: 'Kallbryggt kaffe + 150 g grekisk yoghurt + 10 g valnötter + 1 tsk chiafrön + gurkmeja & olivolja'
  },
  'قهوه سرد + ۱۵۰گ ماست یونانی + ۱۰گ گردو + چیا': {
    en: 'Cold brew + 150g Greek yogurt + 10g walnuts + chia',
    sv: 'Kallbryggt kaffe + 150 g grekisk yoghurt + 10 g valnötter + chia'
  },
  'سینه مرغ + قارچ + روغن زیتون': {
    en: 'Chicken breast + mushrooms + olive oil',
    sv: 'Kycklingbröst + champinjoner + olivolja'
  },

  // Portion sizes
  '۱۵۰گ مرغ + ۸ تا ۱۰ق برنج باقالی': { en: '150g chicken + 8-10 tbsp fava bean rice (400g)', sv: '150 g kyckling + 8-10 msk bondböneris (400 g)' },
  'خورش با ۱۰۰گ گوشت + ۸ق برنج کته': { en: 'Stew with 100g lean beef + 8 tbsp rice (400g)', sv: 'Gryta med 100 g nötkött + 8 msk ris (400 g)' },
  '۱۸۰گ کباب + ۶ تا ۸ق برنج': { en: '180g kebab + 6-8 tbsp rice (400g)', sv: '180 g kebab + 6-8 msk ris (400 g)' },
  '۱ کاسه ۳۵۰ گرمی کامل': { en: '1 full bowl (350g)', sv: '1 hel skål (350 g)' },
  '۲۰۰گ فیله مرغ + ۶ق برنج': { en: '200g chicken fillet + 6 tbsp rice (400g)', sv: '200 g kycklingfilé + 6 msk ris (400 g)' },
  '۵ تا ۶ عدد دلمه متوسط': { en: '5-6 medium dolma (350g)', sv: '5-6 st medelstora dolmar (350 g)' },
  '۲۰۰گ فیله ماهی + ۸ق سبزی پلو': { en: '200g fish fillet + 8 tbsp herb rice (400g)', sv: '200 g fiskfilé + 8 msk örtris (400 g)' },
  '۱ بشقاب کته + ۱۵۰گ ماست + ۳۰گ گردو': { en: '1 plate rice + 150g yogurt + 30g walnuts', sv: '1 tallrik ris + 150 g yoghurt + 30 g valnötter' },
  'خورش با گوشت + ۸ق برنج کته': { en: 'Stew with meat + 8 tbsp rice (400g)', sv: 'Gryta med kött + 8 msk ris (400 g)' },
  '۱ بشقاب پرعدس (۳۵۰ گرم)': { en: '1 plate lentil rice (350g)', sv: '1 tallrik linsris (350 g)' },
  '۳ تکه کوکو + ۱ تکه نان سنگک': { en: '3 pieces kuku + 1 piece Sangak bread (350g)', sv: '3 bitar kuku + 1 bit Sangak-bröd (350 g)' },
  '۱۵۰گ مرغ ترش + ۶ق برنج': { en: '150g sour chicken + 6 tbsp rice (350g)', sv: '150 g syrlig kyckling + 6 msk ris (350 g)' },
  '۱ کاسه بزرگ (۳۰۰ گرم)': { en: '1 large bowl (300g)', sv: '1 stor skål (300 g)' },
  '۲۰۰گ کباب حسینی + ۶ق برنج': { en: '200g Hosseini kebab + 6 tbsp rice (350g)', sv: '200 g Hosseini spettbiff + 6 msk ris (350 g)' },
  '۱۵۰گ گوشت + ۸ق برنج باقالی': { en: '150g beef + 8 tbsp fava bean rice (400g)', sv: '150 g nötkött + 8 msk bondböneris (400 g)' },
  'خورش کامل + ۸ق برنج': { en: '1 full portion stew + 8 tbsp rice (400g)', sv: '1 portion gryta + 8 msk ris (400 g)' },
  '۱۸۰گ کباب + ۶ق برنج': { en: '180g kebab + 6 tbsp rice (350g)', sv: '180 g kebab + 6 msk ris (350 g)' },
  '۱ کاسه ۳۵۰ گرمی': { en: '1 bowl (350g)', sv: '1 skål (350 g)' },
  '۲۰۰گ مرغ + ۶ق برنج': { en: '200g chicken + 6 tbsp rice (350g)', sv: '200 g kyckling + 6 msk ris (350 g)' },
  '۶ عدد دلمه': { en: '6 pieces dolma (350g)', sv: '6 st dolmar (350 g)' },
  '۲۰۰گ ماهی + ۸ق برنج': { en: '200g fish + 8 tbsp rice (400g)', sv: '200 g fisk + 8 msk ris (400 g)' },
  '۱ بشقاب (۳۵۰ گرم)': { en: '1 plate (350g)', sv: '1 tallrik (350 g)' },
  '۱ بشقاب': { en: '1 plate (350g)', sv: '1 tallrik (350 g)' },
  '۳ تکه کوکو + نان سنگک': { en: '3 pieces kuku + Sangak bread (350g)', sv: '3 bitar kuku + Sangak-bröd (350 g)' },
  '۱۵۰گ مرغ + ۶ق برنج': { en: '150g chicken + 6 tbsp rice (350g)', sv: '150 g kyckling + 6 msk ris (350 g)' },
  '۱ کاسه بزرگ': { en: '1 large bowl (350g)', sv: '1 stor skål (350 g)' },
  'خورش بامیه + ۸ق برنج کته': { en: 'Okra stew + 8 tbsp rice (400g)', sv: 'Okragryta + 8 msk ris (400 g)' },
  '۱ کاسه بزرگ با ۳۰گ گردو': { en: '1 large bowl with 30g walnuts (400g)', sv: '1 stor skål med 30 g valnötter (400 g)' },
  '۲۰۰گ کدو + ۱۵۰گ مرغ': { en: '200g zucchini + 150g chicken (350g)', sv: '200 g zucchini + 150 g kyckling (350 g)' },
  '۲۰۰گ ماهی + سبزیجات': { en: '200g fish + roasted vegetables (350g)', sv: '200 g fisk + ugnsrostade grönsaker (350 g)' },
  'خورش + ۸ق برنج کته': { en: '1 portion stew + 8 tbsp rice (400g)', sv: '1 portion gryta + 8 msk ris (400 g)' },
  '۱ تکه ته چین (۳۰۰ گرم)': { en: '1 slice Tahchin (300g)', sv: '1 bit Tahchin (300 g)' },
  'خورش ترش + ۸ق برنج': { en: 'Sour stew + 8 tbsp rice (400g)', sv: 'Syrlig gryta + 8 msk ris (400 g)' },
  '۱ کاسه سالاد بزرگ': { en: '1 large salad bowl (350g)', sv: '1 stor salladsskål (350 g)' },
  '۲۰۰گ مرغ + سبزیجات': { en: '200g chicken + vegetables (350g)', sv: '200 g kyckling + grönsaker (350 g)' },
  '۱۸۰گ چنجه + ۶ق برنج': { en: '180g Chenjeh steak + 6 tbsp rice (350g)', sv: '180 g Chenjeh biff + 6 msk ris (350 g)' },
  'خورش + ۸ق برنج': { en: '1 portion stew + 8 tbsp rice (400g)', sv: '1 portion gryta + 8 msk ris (400 g)' },
  '۱ تکه ته چین': { en: '1 slice Tahchin (300g)', sv: '1 bit Tahchin (300 g)' },
  '۱ کاسه سالاد': { en: '1 salad bowl (300g)', sv: '1 skål sallad (300 g)' },
  'خورش با ۱۵۰گ گردو و مرغ + ۶ق برنج': { en: 'Fesenjan with 150g walnuts & chicken + 6 tbsp rice (400g)', sv: 'Fesenjan med 150 g valnötter & kyckling + 6 msk ris (400 g)' },
  'خورش به + ۸ق برنج کته': { en: 'Quince stew + 8 tbsp rice (400g)', sv: 'Kvittengryta + 8 msk ris (400 g)' },
  '۳ عدد کتلت + نان سنگک': { en: '3 cutlets + Sangak bread (350g)', sv: '3 st kotletter + Sangak-bröd (350 g)' },
  '۲ سیخ کوبیده + ۸ق برنج': { en: '2 skewers Koobideh + 8 tbsp rice (450g)', sv: '2 spett Koobideh + 8 msk ris (450 g)' },
  'خورش اسفناج + ۸ق برنج': { en: 'Spinach stew + 8 tbsp rice (400g)', sv: 'Spenatgryta + 8 msk ris (400 g)' },
  '۱ تکه مرغ + ۶ق برنج': { en: '1 piece chicken + 6 tbsp rice (350g)', sv: '1 bit kyckling + 6 msk ris (350 g)' },
  'خوراک کدو + نان جو': { en: 'Pumpkin stew + barley bread (350g)', sv: 'Pumpagryta + kornbröd (350 g)' },
  '۱ کاسه خوراک + ۶ق برنج': { en: '1 bowl stew + 6 tbsp rice (350g)', sv: '1 skål gryta + 6 msk ris (350 g)' },
  '۳ عدد شامی + نان سنگک': { en: '3 pieces shami + Sangak bread (350g)', sv: '3 st shami + Sangak-bröd (350 g)' },
  '۲۰۰گ سالمون تنوری': { en: '200g baked salmon (350g)', sv: '200 g ugnsbakad lax (350 g)' },
  '۳ عدد کتلت + نان': { en: '3 cutlets + bread (350g)', sv: '3 st kotletter + fullkornsbröd (350 g)' },
  '۲ سیخ + ۸ق برنج': { en: '2 skewers kebab + 8 tbsp rice (450g)', sv: '2 spett kebab + 8 msk ris (450 g)' },
  'خوراک + نان': { en: 'Stew + bread (350g)', sv: 'Gryta + bröd (350 g)' },
  '۱ کاسه + ۶ق برنج': { en: '1 bowl stew + 6 tbsp rice (350g)', sv: '1 skål gryta + 6 msk ris (350 g)' },
  '۳ عدد شامی + نان': { en: '3 pieces shami + bread (350g)', sv: '3 st shami + bröd (350 g)' },
  '۲۰۰گ سالمون': { en: '200g salmon fillet (350g)', sv: '200 g laxfilé (350 g)' },
  'خورش قیمه + ۸ق برنج': { en: 'Gheimeh stew + 8 tbsp rice (400g)', sv: 'Gheimeh-gryta + 8 msk ris (400 g)' },
  '۱ کاسه بزرگ (۴۰۰ گرم)': { en: '1 large bowl (400g)', sv: '1 stor skål (400 g)' },
  '۱ کاسه آبگوشت + ۱ تکه نان': { en: '1 bowl abgoosht + 1 piece bread (400g)', sv: '1 skål abgoosht + 1 bit bröd (400 g)' },
  '۱ بشقاب نرگسی + نان سنگک': { en: '1 plate Nargesi + Sangak bread (350g)', sv: '1 tallrik Nargesi + Sangak-bröd (350 g)' },
  'خورش کدو + ۸ق برنج': { en: 'Zucchini stew + 8 tbsp rice (400g)', sv: 'Zucchinigryta + 8 msk ris (400 g)' },
  '۱ بشقاب خوراک + نان': { en: '1 plate stew + bread (350g)', sv: '1 tallrik gryta + bröd (350 g)' },
  '۱۵۰گ گوشت + نان سنگک': { en: '150g beef + Sangak bread (350g)', sv: '150 g nötkött + Sangak-bröd (350 g)' },
  '۱ عدد کوفته بزرگ + نان': { en: '1 large meatball + bread (350g)', sv: '1 st stor köttbulle + bröd (350 g)' },
  'خورش لپه + ۸ق برنج': { en: 'Split pea stew + 8 tbsp rice (400g)', sv: 'Gula ärtor-gryta + 8 msk ris (400 g)' },
  '۱ بشقاب + نان': { en: '1 plate + bread (350g)', sv: '1 tallrik + bröd (350 g)' },
  '۲۰۰گ مرغ + بروکلی': { en: '200g chicken + broccoli (350g)', sv: '200 g kyckling + broccoli (350 g)' },
  '۱ کاسه دیزی + نان': { en: '1 bowl dizi + bread (400g)', sv: '1 skål dizi + bröd (400 g)' },
  '۱ عدد کوفته + نان': { en: '1 meatball + bread (350g)', sv: '1 st köttbulle + bröd (350 g)' },
  '۱ کاسه (۲۵۰ml)': { en: '1 bowl (250ml)', sv: '1 skål (250 ml)' },
  '۱ لیوان (۲۵۰ml)': { en: '1 glass (250ml)', sv: '1 glas (250 ml)' },
  '۱ کاسه (۱۵۰ گرم)': { en: '1 bowl (150g)', sv: '1 skål (150 g)' },
  '۱ کاسه (۲۰۰ گرم)': { en: '1 bowl (200g)', sv: '1 skål (200 g)' },
  '۱ کاسه (۲۵۰ گرم)': { en: '1 bowl (250g)', sv: '1 skål (250 g)' },
  '۱ کاسه (۳۰۰ گرم)': { en: '1 bowl (300g)', sv: '1 skål (300 g)' },
  '۱ کاسه (۳۵۰ گرم)': { en: '1 bowl (350g)', sv: '1 skål (350 g)' },
  '۱ کاسه (۱۲۰ گرم)': { en: '1 bowl (120g)', sv: '1 skål (120 g)' },
  '۱ کاسه با مخلفات (۴۰۰ گرم)': { en: '1 bowl with sides (400g)', sv: '1 skål med tillbehör (400 g)' },
  '۱ لیوان (۲۴۰ میلی)': { en: '1 glass (240ml)', sv: '1 glas (240 ml)' },
  '۱ لیوان (۲۵۰ میلی)': { en: '1 glass (250ml)', sv: '1 glas (250 ml)' },
  '۱ لیوان (۳۰۰ میلی)': { en: '1 glass (300ml)', sv: '1 glas (300 ml)' },
  '۱ لیوان (۲۴۰ گرم)': { en: '1 cup (240g)', sv: '1 glas (240 g)' },
  '۱ فنجان (۲۰۰ میلی)': { en: '1 cup (200ml)', sv: '1 kopp (200 ml)' },
  '۱ فنجان (۱۵۰ میلی)': { en: '1 cup (150ml)', sv: '1 kopp (150 ml)' },
  '۱ شات (۳۰ میلی)': { en: '1 shot (30ml)', sv: '1 shot (30 ml)' },
  '۱ پیمانه (۱۵۰ گرم)': { en: '1 portion (150g)', sv: '1 portion (150 g)' },
  '۱ پیمانه (۲۰۰ گرم)': { en: '1 bowl (200g)', sv: '1 skål (200 g)' },
  '۱ پیمانه (۳۰ گرم)': { en: '1 scoop (30g)', sv: '1 skopa (30 g)' },
  '۱ پرس با برنج (۴۵۰ گرم)': { en: '1 portion with rice (450g)', sv: '1 portion med ris (450 g)' },
  '۱ پرس با برنج (۴۰۰ گرم)': { en: '1 portion with rice (400g)', sv: '1 portion med ris (400 g)' },
  '۱ پرس کامل (۴۰۰ گرم)': { en: '1 portion (400g)', sv: '1 portion (400 g)' },
  '۱ پرس کامل (۴۵۰ گرم)': { en: '1 portion (450g)', sv: '1 portion (450 g)' },
  '۱ پرس کامل (۵۰۰ گرم)': { en: '1 portion (500g)', sv: '1 portion (500 g)' },
  '۱ پرس کامل (۳۵۰ گرم)': { en: '1 portion (350g)', sv: '1 portion (350 g)' },
  '۱ لقمه کامل (۱۲۰ گرم)': { en: '1 wrap (120g)', sv: '1 portion (120 g)' },
  '۱ نان کامل (۷۰ گرم)': { en: '1 flatbread (70g)', sv: '1 helt bröd (70 g)' },
  '۱ نان کامل (۱۰۰ گرم)': { en: '1 flatbread (100g)', sv: '1 helt bröd (100 g)' },
  '۱ عدد بزرگ (۲۰۰ گرم)': { en: '1 large (200g)', sv: '1 st stor (200 g)' },
  '۱ عدد بزرگ (۳۰۰ گرم)': { en: '1 large (300g)', sv: '1 st stor (300 g)' },
  '۱ عدد متوسط (۱۵۰ گرم)': { en: '1 medium (150g)', sv: '1 st medelstor (150 g)' },
  '۱ عدد متوسط (۱۲۰ گرم)': { en: '1 medium (120g)', sv: '1 st medelstor (120 g)' },
  '۱ عدد متوسط (۱۸۰ گرم)': { en: '1 medium (180g)', sv: '1 st medelstor (180 g)' },
  '۱ عدد (۹۰ گرم)': { en: '1 piece (90g)', sv: '1 st (90 g)' },
  '۱ عدد (۱۲۰ گرم)': { en: '1 piece (120g)', sv: '1 st (120 g)' },
  '۱ عدد (۱۳۰ گرم)': { en: '1 piece (130g)', sv: '1 st (130 g)' },
  '۱ عدد (۱۰۰ گرم)': { en: '1 piece (100g)', sv: '1 st (100 g)' },
  '۱ عدد (۱۵۰ گرم)': { en: '1 piece (150g)', sv: '1 st (150 g)' },
  '۱ عدد (۲۰۰ گرم)': { en: '1 piece (200g)', sv: '1 st (200 g)' },
  '۱ عدد کامل (۶۰ گرم)': { en: '1 whole (60g)', sv: '1 st hel (60 g)' },
  '۱ تکه بزرگ (۳۰۰ گرم)': { en: '1 large slice (300g)', sv: '1 stor bit (300 g)' },
  '۱ تکه بزرگ (۱۰۰ گرم)': { en: '1 large piece (100g)', sv: '1 stor bit (100 g)' },
  '۱ برش (۳۰۰ گرم)': { en: '1 slice (300g)', sv: '1 skiva (300 g)' },
  '۱ برش (۲۵۰ گرم)': { en: '1 slice (250g)', sv: '1 skiva (250 g)' },
  '۲ برش (۶۰ گرم)': { en: '2 slices (60g)', sv: '2 skivor (60 g)' },
  '۱ بشقاب (۲۰۰ گرم)': { en: '1 plate (200g)', sv: '1 tallrik (200 g)' },
  '۱ بشقاب (۲۵۰ گرم)': { en: '1 plate (250g)', sv: '1 tallrik (250 g)' },
  '۱ بشقاب (۳۰۰ گرم)': { en: '1 plate (300g)', sv: '1 tallrik (300 g)' },
  '۳ تکه (۱۵۰ گرم)': { en: '3 pieces (150g)', sv: '3 bitar (150 g)' },
  '۳ عدد (۱۸۰ گرم)': { en: '3 pieces (180g)', sv: '3 st (180 g)' },
  '۴ عدد (۲۵۰ گرم)': { en: '4 pieces (250g)', sv: '4 st (250 g)' },
  '۴ عدد (۵۰ گرم)': { en: '4 pieces (50g)', sv: '4 st (50 g)' },
  '۴ عدد (۱۳۰ گرم)': { en: '4 pieces (130g)', sv: '4 st (130 g)' },
  '۳ عدد (۱۰۰ گرم)': { en: '3 pieces (100g)', sv: '3 st (100 g)' },
  '۳ عدد (۴۵ گرم)': { en: '3 pieces (45g)', sv: '3 st (45 g)' },
  '۲ عدد (۱۵۰ گرم)': { en: '2 pieces (150g)', sv: '2 st (150 g)' },
  '۲ عدد (۱۴۰ گرم)': { en: '2 pieces (140g)', sv: '2 st (140 g)' },
  '۲ عدد (۱۱۰ گرم)': { en: '2 large (110g)', sv: '2 st stora (110 g)' },
  '۲ عدد (۱۲۰ گرم)': { en: '2 pieces (120g)', sv: '2 st (120 g)' },
  '۲ عدد (۱۶۰ گرم)': { en: '2 pieces (160g)', sv: '2 st (160 g)' },
  '۲ قاشق (۵۰ گرم)': { en: '2 tbsp (50g)', sv: '2 msk (50 g)' },
  '۲ قاشق (۳۰ گرم)': { en: '2 tbsp (30g)', sv: '2 msk (30 g)' },
  '۱ قاشق (۱۵ گرم)': { en: '1 tbsp (15g)', sv: '1 msk (15 g)' },
  '۱۰ عدد (۴۰ گرم)': { en: '10 pieces (40g)', sv: '10 st (40 g)' },
  '۱ خوشه (۱۵۰ گرم)': { en: '1 cluster (150g)', sv: '1 klase (150 g)' },
  '۲ حلقه (۱۲۰ گرم)': { en: '2 slices (120g)', sv: '2 skivor (120 g)' },
  'نصف عدد (۱۰۰ گرم)': { en: '1/2 piece (100g)', sv: '1/2 st (100 g)' },
  '۱ قوطی (۱۸۰ گرم)': { en: '1 can (180g)', sv: '1 burk (180 g)' },
  '۱ سیخ بدون برنج (۲۰۰ گرم)': { en: '1 skewer (200g)', sv: '1 spett (200 g)' },
  '۲ ق خامه + ۱ ق عسل (۷۰ گرم)': { en: '2 tbsp cream + 1 tbsp honey (70g)', sv: '2 msk grädde + 1 msk honung (70 g)' },
  '۲۰گ کره + ۲ق مربا (۶۰ گرم)': { en: '20g butter + 2 tbsp jam (60g)', sv: '20 g smör + 2 msk sylt (60 g)' },
  '۵۰ گرم': { en: '50g', sv: '50 g' },
  '۱۰۰ گرم': { en: '100g', sv: '100 g' },
  '۱۵۰ گرم': { en: '150g', sv: '150 g' },
  '۲۰۰ گرم': { en: '200g', sv: '200 g' },
  '۳۰ گرم': { en: '30g', sv: '30 g' },
  'یک مشت (۳۰ گرم)': { en: '1 handful (30g)', sv: '1 näve (30 g)' }
};

// Days of week dictionary
const DAYS_OF_WEEK_MAP: Record<string, { en: string; sv: string }> = {
  'شنبه': { en: 'Saturday', sv: 'Lördag' },
  'یکشنبه': { en: 'Sunday', sv: 'Söndag' },
  'دوشنبه': { en: 'Monday', sv: 'Måndag' },
  'سه‌شنبه': { en: 'Tuesday', sv: 'Tisdag' },
  'چهارشنبه': { en: 'Wednesday', sv: 'Onsdag' },
  'پنج‌شنبه': { en: 'Thursday', sv: 'Torsdag' },
  'جمعه': { en: 'Friday', sv: 'Fredag' }
};

// Season names and months dictionary
const SEASONS_MAP: Record<string, { nameEn: string; nameSv: string; monthsEn: string; monthsSv: string }> = {
  spring: {
    nameEn: 'Spring',
    nameSv: 'Vår',
    monthsEn: 'March, April, May (Farvardin, Ordibehesht, Khordad)',
    monthsSv: 'Mars, April, Maj (Vårsäsong)'
  },
  summer: {
    nameEn: 'Summer',
    nameSv: 'Sommar',
    monthsEn: 'June, July, August (Tir, Mordad, Shahrivar)',
    monthsSv: 'Juni, Juli, Augusti (Sommarsäsong)'
  },
  autumn: {
    nameEn: 'Autumn',
    nameSv: 'Höst',
    monthsEn: 'September, October, November (Mehr, Aban, Azar)',
    monthsSv: 'September, Oktober, November (Höstsäsong)'
  },
  winter: {
    nameEn: 'Winter',
    nameSv: 'Vinter',
    monthsEn: 'December, January, February (Dey, Bahman, Esfand)',
    monthsSv: 'December, Januari, Februari (Vintersäsong)'
  }
};

const DIFFICULTY_MAP: Record<string, { en: string; sv: string }> = {
  'آسان': { en: 'Easy', sv: 'Lätt' },
  'متوسط': { en: 'Medium', sv: 'Medel' },
  'سخت': { en: 'Advanced', sv: 'Avancerad' }
};

function normalizeFarsiText(text: string): string {
  return text
    .replace(/[\u200B-\u200F\uFEFF\u00A0]/g, ' ') // zero-width & non-breaking spaces
    .replace(/[\u200c]/g, ' ') // ZWNJ
    .replace(/ي/g, 'ی')
    .replace(/ك/g, 'ک')
    .replace(/[۰-۹]/g, d => '0123456789'['۰۱۲۳۴۵۶۷۸۹'.indexOf(d)])
    .replace(/[\(\)\[\]\{\}«»"']/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function getLocalizedFoodItem(name: string, quantity?: string, lang: Language = 'fa'): { name: string; quantity: string } {
  const defaultQty = quantity ? getLocalizedFoodText(quantity, lang) : '';
  if (lang === 'fa' || !name) return { name, quantity: quantity || '' };

  const trimmed = name.trim();
  const normalized = normalizeFarsiText(trimmed);

  // Exact match
  let entry = FOOD_TRANSLATIONS[trimmed] || PHRASE_TRANSLATIONS[trimmed];
  if (!entry) {
    // Try normalized match
    for (const [key, val] of Object.entries({ ...FOOD_TRANSLATIONS, ...PHRASE_TRANSLATIONS })) {
      if (normalizeFarsiText(key) === normalized) {
        entry = val;
        break;
      }
    }
  }

  if (entry) {
    const locName = (lang === 'sv' ? entry.sv : entry.en) || trimmed;
    const locQty = ('svQty' in entry && (lang === 'sv' ? (entry as { svQty?: string }).svQty : (entry as { enQty?: string }).enQty)) 
      || defaultQty 
      || (lang === 'sv' ? '1 portion (400 g)' : '1 serving (400g)');
    return { name: locName, quantity: locQty };
  }

  // Check if contains + and translate parts
  if (trimmed.includes('+')) {
    const parts = trimmed.split('+').map(p => getLocalizedFoodText(p.trim(), lang));
    return { name: parts.join(' + '), quantity: defaultQty || (lang === 'sv' ? '1 portion (400 g)' : '1 serving (400g)') };
  }

  return { name: getLocalizedFoodText(trimmed, lang), quantity: defaultQty };
}

export function getLocalizedDayName(faDayName: string, lang: Language): string {
  if (lang === 'fa' || !faDayName) return faDayName;
  const match = DAYS_OF_WEEK_MAP[faDayName] || DAYS_OF_WEEK_MAP[faDayName.trim()];
  if (!match) return faDayName;
  return lang === 'sv' ? match.sv : match.en;
}

export function getLocalizedSeasonName(seasonId: 'spring' | 'summer' | 'autumn' | 'winter', lang: Language): string {
  if (lang === 'fa') {
    const faNames = { spring: 'بهار', summer: 'تابستان', autumn: 'پاییز', winter: 'زمستان' };
    return faNames[seasonId] || seasonId;
  }
  const s = SEASONS_MAP[seasonId];
  if (!s) return seasonId;
  return lang === 'sv' ? s.nameSv : s.nameEn;
}

export function getLocalizedSeasonMonths(seasonId: 'spring' | 'summer' | 'autumn' | 'winter', lang: Language): string {
  if (lang === 'fa') {
    const faMonths = {
      spring: 'فروردین، اردیبهشت، خرداد',
      summer: 'تیر، مرداد، شهریور',
      autumn: 'مهر، آبان، آذر',
      winter: 'دی، بهمن، اسفند'
    };
    return faMonths[seasonId] || '';
  }
  const s = SEASONS_MAP[seasonId];
  if (!s) return '';
  return lang === 'sv' ? s.monthsSv : s.monthsEn;
}

export function getLocalizedDifficulty(difficulty: string, lang: Language): string {
  if (lang === 'fa' || !difficulty) return difficulty;
  const match = DIFFICULTY_MAP[difficulty] || DIFFICULTY_MAP[difficulty.trim()];
  if (!match) return difficulty;
  return lang === 'sv' ? match.sv : match.en;
}

export function getLocalizedShoppingItem(item: string, lang: Language): string {
  if (lang === 'fa' || !item) return item;
  const trimmed = item.trim();
  const phrase = PHRASE_TRANSLATIONS[trimmed] || FOOD_TRANSLATIONS[trimmed];
  if (phrase) {
    return lang === 'sv' ? phrase.sv : phrase.en;
  }
  return getLocalizedFoodText(trimmed, lang);
}

export function getLocalizedFoodText(text: string, lang: Language): string {
  if (lang === 'fa' || !text) return text;
  const trimmed = text.trim();
  
  // Exact match
  const match = PHRASE_TRANSLATIONS[trimmed] || FOOD_TRANSLATIONS[trimmed];
  if (match) {
    return lang === 'sv' ? match.sv : match.en;
  }

  // Normalized match
  const normalized = normalizeFarsiText(trimmed);
  for (const [key, val] of Object.entries({ ...PHRASE_TRANSLATIONS, ...FOOD_TRANSLATIONS })) {
    if (normalizeFarsiText(key) === normalized) {
      return lang === 'sv' ? val.sv : val.en;
    }
  }

  // Handle + separated composite ingredients
  if (trimmed.includes('+')) {
    const parts = trimmed.split('+').map(part => {
      const p = part.trim();
      const pMatch = PHRASE_TRANSLATIONS[p] || FOOD_TRANSLATIONS[p];
      if (pMatch) return lang === 'sv' ? pMatch.sv : pMatch.en;
      const pNorm = normalizeFarsiText(p);
      for (const [k, v] of Object.entries({ ...PHRASE_TRANSLATIONS, ...FOOD_TRANSLATIONS })) {
        if (normalizeFarsiText(k) === pNorm) {
          return lang === 'sv' ? v.sv : v.en;
        }
      }
      return p;
    });
    return parts.join(' + ');
  }

  // Handle comma separated
  if (trimmed.includes('،') || trimmed.includes(',')) {
    const sep = trimmed.includes('،') ? '،' : ',';
    const parts = trimmed.split(sep).map(part => {
      const p = part.trim();
      const pMatch = PHRASE_TRANSLATIONS[p] || FOOD_TRANSLATIONS[p];
      if (pMatch) return lang === 'sv' ? pMatch.sv : pMatch.en;
      const pNorm = normalizeFarsiText(p);
      for (const [k, v] of Object.entries({ ...PHRASE_TRANSLATIONS, ...FOOD_TRANSLATIONS })) {
        if (normalizeFarsiText(k) === pNorm) {
          return lang === 'sv' ? v.sv : v.en;
        }
      }
      return p;
    });
    return parts.join(', ');
  }

  return trimmed;
}

export function getLocalizedFoodQuantity(qty: string, lang: Language): string {
  if (!qty) return '';
  if (lang === 'fa') return qty;

  let res = qty;
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  farsiDigits.forEach((d, i) => {
    res = res.replace(new RegExp(d, 'g'), String(i));
  });

  if (lang === 'sv') {
    res = res
      .replace(/کیلوگرم/g, 'kg')
      .replace(/میلی‌لیتر/g, 'ml')
      .replace(/گرم/g, 'g')
      .replace(/لیتر/g, 'L')
      .replace(/عدد/g, 'st')
      .replace(/پرس/g, 'portion')
      .replace(/لیوان/g, 'glas')
      .replace(/فنجان/g, 'kopp')
      .replace(/قاشق غذاخوری/g, 'msk')
      .replace(/قاشق چای‌خوری/g, 'tsk')
      .replace(/قاشق/g, 'sked')
      .replace(/سیخ/g, 'spett')
      .replace(/تکه/g, 'bit')
      .replace(/برش/g, 'skiva')
      .replace(/کاسه/g, 'skål')
      .replace(/بشقاب/g, 'tallrik')
      .replace(/مشک/g, 'näve')
      .replace(/مشت/g, 'näve')
      .replace(/کامل/g, 'hel')
      .replace(/متوسط/g, 'medelstor')
      .replace(/بزرگ/g, 'stor')
      .replace(/کوچک/g, 'liten')
      .replace(/بدون/g, 'utan')
      .replace(/با/g, 'med')
      .replace(/وزن/g, 'vikt')
      .replace(/سوسیس بندری/g, 'Bandari korv')
      .replace(/نان باگت/g, 'baguette')
      .replace(/یک ساندویچ/g, '1 smörgås');
  } else if (lang === 'en') {
    res = res
      .replace(/کیلوگرم/g, 'kg')
      .replace(/میلی‌لیتر/g, 'ml')
      .replace(/گرم/g, 'g')
      .replace(/لیتر/g, 'L')
      .replace(/عدد/g, 'pcs')
      .replace(/پرس/g, 'portion')
      .replace(/لیوان/g, 'glass')
      .replace(/فنجان/g, 'cup')
      .replace(/قاشق غذاخوری/g, 'tbsp')
      .replace(/قاشق چای‌خوری/g, 'tsp')
      .replace(/قاشق/g, 'spoon')
      .replace(/سیخ/g, 'skewer')
      .replace(/تکه/g, 'piece')
      .replace(/برش/g, 'slice')
      .replace(/کاسه/g, 'bowl')
      .replace(/بشقاب/g, 'plate')
      .replace(/مشت/g, 'handful')
      .replace(/کامل/g, 'whole')
      .replace(/متوسط/g, 'medium')
      .replace(/بزرگ/g, 'large')
      .replace(/کوچک/g, 'small');
  }

  return res.trim();
}

// Localized Habits mapping
export const LOCALIZED_HABITS_MAP: Record<string, {
  en: { title: string; shortDesc: string; benefits: string[]; howToPrepare?: string };
  sv: { title: string; shortDesc: string; benefits: string[]; howToPrepare?: string };
}> = {
  habit_coffee_glp1: {
    en: {
      title: 'GLP-1 Health Coffee (Cold Brew / Espresso + Walnuts & Chia)',
      shortDesc: 'Invigorating beverage optimized to maximize GLP-1 and GIP satiety hormone elevation',
      benefits: [
        '3x stimulation of GLP-1 & GIP hormone release for prolonged cellular fullness',
        'Rich in chlorogenic acid polyphenols to halt systemic inflammatory cascades',
        'Stabilizes postprandial glucose curves without insulin spikes',
        '2,000x enhanced curcumin absorption via black pepper, turmeric, and virgin olive oil synergy'
      ],
      howToPrepare: '200ml iced cold brew (or 2 espresso shots over ice) + 150g Greek yogurt + 10g crushed walnuts + 1 tsp chia seeds + pinch of turmeric + pinch of black pepper + 5ml extra virgin olive oil.'
    },
    sv: {
      title: 'GLP-1 Hälsokaffe (Cold Brew / Espresso + Valnötter & Chia)',
      shortDesc: 'Uppfriskande och mättande kaffedryck som maximerar utsöndringen av mättnadshormonerna GLP-1 och GIP',
      benefits: [
        '3x stimulering av GLP-1- och GIP-hormonfrisättning för djup och långvarig mättnad',
        'Rik på kraftfulla klorogensyra-antioxidanter som motverkar cellulär inflammation',
        'Stabiliserar blodsockret och motverkar plötsliga insulintoppar',
        '2000x ökad absorption av kurkumin genom synergisk kombination av gurkmeja, svartpeppar och olivolja'
      ],
      howToPrepare: '200 ml kallbryggt kaffe (eller 2 shots espresso över is) + 150 g grekisk yoghurt + 10 g hackade valnötter + 1 tsk chiafrön + nypa gurkmeja + nypa svartpeppar + 5 ml extra jungfruolivolja.'
    }
  },
  habit_fiber_starter: {
    en: {
      title: 'Fiber-First Appetizer (Watercress / Fresh Shirazi Salad)',
      shortDesc: 'Consume fresh leafy watercress or Shirazi salad with olive oil 10 min before main meal',
      benefits: [
        'Creates a viscous fiber mesh in the stomach, slowing glucose absorption by up to 50%',
        'Bitter leafy greens (watercress, parsley) trigger natural GLP-1 enteroendocrine pumps',
        'Reduces main meal volume, eliminating post-meal bloating and lethargy'
      ]
    },
    sv: {
      title: 'Fiberförrätt (Färsk krasse / Shirazi-sallad)',
      shortDesc: 'Ät färsk vattenkrasse eller Shirazi-sallad med olivolja 10 minuter före huvudmåltiden',
      benefits: [
        'Skapar ett skyddande fibernät i magsäcken som halverar blodsockerstoppen från kolhydrater',
        'Bittra bladgrönsaker (krasse, persilja) aktiverar tarmens naturliga GLP-1-pumpar',
        'Minskar portionsbehovet vid huvudmåltiden och förhindrar matkoma'
      ]
    }
  },
  habit_no_sugar: {
    en: {
      title: 'Zero Artificial Sugars & Sweetened Beverages',
      shortDesc: 'Swap sugary drinks for natural bitter teas, sparkling mineral water, or black coffee',
      benefits: [
        'Eliminates insulin spikes and blocks visceral abdominal fat accumulation',
        'Sustains clean metabolic energy and prevents rebound hunger crashes'
      ]
    },
    sv: {
      title: 'Eliminera tillsatt socker & sötade drycker',
      shortDesc: 'Ersätt sötat te och läsk med osötat te, kolsyrat vatten eller svart kaffe',
      benefits: [
        'Förhindrar kraftiga insulintoppar och blockerar inlagring av bukfett',
        'Ger jämn energi och motverkar falska hungerkänslor 30 minuter efter intag'
      ]
    }
  },
  habit_golden_mix: {
    en: {
      title: 'The Golden Synergy (Turmeric + Black Pepper + Olive Oil)',
      shortDesc: 'Dust every meal with a shaker bottle containing turmeric powder, cracked pepper & olive oil',
      benefits: [
        '2,000x boosted curcumin bioavailability to suppress systemic metabolic inflammation',
        'Potent natural appetite suppression and metabolic liver support'
      ]
    },
    sv: {
      title: 'Den gyllene formeln (Gurkmeja + Svartpeppar + Olivolja)',
      shortDesc: 'Strö en blandning av gurkmeja och nymalen svartpeppar över alla rätter och sallader',
      benefits: [
        '2000x ökad biotillgänglighet för kurkumin för att dämpa kronisk metabol inflammation',
        'Starkt aptitreglerande samt stöd för fettlever och tarmhälsa'
      ]
    }
  },
  habit_water_hydrate: {
    en: {
      title: 'Optimal Hydration (8 Glasses of Fresh Water with Lemon)',
      shortDesc: 'Drink fresh water with a splash of lemon between meals to maintain cellular hydration',
      benefits: [
        'Flushes metabolic toxins and accelerates cellular fatty acid oxidation',
        'Prevents mistaking dehydration for hunger signals'
      ]
    },
    sv: {
      title: 'Optimal hydrering (8 glas rent vatten med citron)',
      shortDesc: 'Drick tillräckligt med vatten smaksatt med färsk citron mellan måltider',
      benefits: [
        'Underlättar utrensning av metabola slaggprodukter och optimerar fettförbränning',
        'Förhindrar att hjärnan misstolkar törst som falsk hunger'
      ]
    }
  }
};

export function getLocalizedHabit(habit: {
  id: string;
  title: string;
  shortDesc: string;
  benefits: string[];
  howToPrepare?: string;
  isCustom?: boolean;
}, lang: Language): {
  title: string;
  shortDesc: string;
  benefits: string[];
  howToPrepare?: string;
} {
  if (lang === 'fa' || habit.isCustom) {
    return {
      title: habit.title,
      shortDesc: habit.shortDesc,
      benefits: habit.benefits,
      howToPrepare: habit.howToPrepare
    };
  }

  const localized = LOCALIZED_HABITS_MAP[habit.id];
  if (!localized) {
    return {
      title: habit.title,
      shortDesc: habit.shortDesc,
      benefits: habit.benefits,
      howToPrepare: habit.howToPrepare
    };
  }

  const item = lang === 'sv' ? localized.sv : localized.en;
  return {
    title: item.title,
    shortDesc: item.shortDesc,
    benefits: item.benefits,
    howToPrepare: item.howToPrepare || habit.howToPrepare
  };
}
